import React, { Component } from "react";
import { Field, reduxForm, change } from 'redux-form';

import BlockIcon from "@material-ui/icons/Block";
import { Button } from "@material-ui/core";

import { connect } from 'react-redux';
import Alert from 'react-s-alert';

import { PutUserByCommunity } from '../../actions/communityActions';
import { getResidentsByCommunity, AddResident, UpdResident, DelResident, getALLResidentsByCommunityIDPagination, SyncResidentsByCommunity } from '../../actions/residentActions';
import { BlockFamiliar } from '../../actions/familiarAction';

import Grid from '@material-ui/core/Grid';
import SwipeableViews from 'react-swipeable-views';
import Box from '@material-ui/core/Box';
import PropTypes from 'prop-types';
import Modal from '@material-ui/core/Modal'
import Paper from '@material-ui/core/Paper'
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import TextField from '@material-ui/core/TextField'
import { GeneralAlert } from '../../components/Alert/Alert';
import { AddDetailsImage } from '../../actions/activityAction'

//Modals
import ConnectInvitationModal from '../../views/community/ConnectInvitationModal'

//Engage Components
import { sweetAlert, SweetConfirmationAlert } from '../../components/Alert/sweetAlert';
import ResidentsFiltersDrawer from "./ResidentsFiltersDrawer";
import {
    renderSelect,
    renderSwitchV2,
    renderSwitchWithLabel,
    renderTextFieldWithChips,
    renderSingleDateFormattedPicker,
    RenderImageLoader,
    SimpleCard,
    renderTimePicker
} from '../../utils/engageComponents';

import {
    SYNC_RESIDENTS_BY_COMMUNITY_SUCCESS
} from '../../constants/residentConstants';

const validate = (values) => {
    const errors = {};

    return errors;
};


const TabPanel = (props) => {
    const { children, value, index, ...other } = props;


    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}
        >

            {value === index && (
                <Box p={3} >
                    <Grid>{children}</Grid>
                </Box>
            )}
        </div>
    );
};

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

class AddEditResident extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: true,
            action: props.data && props.data._id ? 'edit' : 'new',
            _id: props.data._id,
            //Modal
            openModal: false,
            activeStep: 0,
            modalNewTagText: '',
            modalChipsArray: [],
            modalnewResidentArray: [],
            modalFirstName: '',
            modalLastName: '',
            modalLocation: '',
            selectedResidentImage: 'https://engage360.s3.amazonaws.com/Residents/profile.png',
            modalBirthDay: undefined,
            onErrorModalFirstName: false,
            onErrorModalLastName: false,
            onErrorModalLocation: false,
            onErrorModalBirthDay: false,
            errorGenericText: 'Required Field',
            //UpdResidents
            isUpdResident: false,
            residentSelected: undefined,
            selectedResidentFirstName: '',
            selectedResidentLastName: '',
            selectedResidentLocation: '',
            selectedResidentBirthday: '',
            selectedResidentIdentifiers: [],
            selectedResidentDevices: [],
            selectedResidentFamilyMembers: [],
            selectedResidentUrlPicture: '',
            selectedResidentTagText: '',
            residentPictureType: '',
            residentPictureName: '',
            residentPictureFile: '',
            residentUpdatePicture: false,

            onErrorSelectedResidentFirstName: false,
            onErrorSelectedResidentLastName: false,
            onErrorSelectedResidentBirthDay: false,

            commonName: '',
            onErrorCommonName: false,

            //dateFormat
            dateFormat: 'MMMM dd, yyyy',
            //timeouts
            timeouts: [],
            //rootFontSize
            rootFontSize: {
                name: 'xs',
                fontSize: '58%',
                maxWidht: 600,
            },
            //ConnectInvitation
            openConnectInvitationModal: false,
            connectModalInfo: undefined,

            //FiltersComponent
            openFilters: false,
            AnchorElId: undefined,
            filterObj: undefined,
            residents: this.props.residentData ? this.props.residentData : [],

            //Additional information
            //Marital status
            maritalStatusOptionsSelected: undefined,
            openMaritalStatus: false,


            //Wedding anniversary
            dateFormatAnniversary: 'MMMM dd, yyyy',
            weddingAnniversary: undefined,

            //Veteran
            veteranComponentOptionSelected: undefined,
            openVeteranComponent: false,

            //MoveIn Date
            moveInDate: undefined,
            dateFormatMoveIn: 'MMMM dd, yyyy',

            //Sex component
            sexOptionSelected: undefined,
            openSexComponent: undefined,

            //Engage Preference
            openEngagePreferenceComponent: false,
            engagePreferenceOptionSelected: undefined,

            //spirituality
            spiritualityOptionSelected: undefined,
            openSpiritualityComponent: false,

            //Language
            openLanguageComponent: false,
            languageOptionSelected: undefined,

            //children
            children: false,
            childrenQty: undefined,

            //grandchildren
            grandchildren: false,
            grandChildrenQty: undefined,

            //eHubInitiationDate
            eHubInitiationDate: undefined,
            dateFormatEhubInitiationDate: 'MMMM dd, yyyy',

            //Normal wake time
            normalWakeTime: undefined,

            //Normal bed time
            normalBedTime: undefined,
            isVoiceAvailable: props.data.isVoiceAvailable !== undefined ? props.data.isVoiceAvailable : true
        };

        this.observer = React.createRef();
        this.lastActivityRef = node => {
            /* FUNCTION CALL BACK */
            if (this.observer.current) this.observer.current.disconnect();
            this.observer.current = new IntersectionObserver(entries => {
                if (entries[0].isIntersecting) {
                    this.setState((prevState) => ({ currentPage: prevState.currentPage + 1 }), () => {
                        const communityId = localStorage.getItem('communityId');

                        if (!communityId) return undefined;
                        this.props.getALLResidentsByCommunityIDPagination(communityId, this.state.currentPage);
                    })
                }

            });
            if (node) this.observer.current.observe(node)
        }


    }


    pushTimeouts(newTimeout) {
        const oldTimeouts = this.state.timeouts;
        if (newTimeout) {
            this.setState({ timeouts: [...oldTimeouts, newTimeout] })
        }
    }
    //This method will run once the component is deploy to the browser
    componentDidMount() {
        document.title='Community - Residents'


        //this.props.handleIsUpdResident(true);
        if (this.props.data._id) {
            this.setState({ currentPage: 1 }, () => {
                const communityId = localStorage.getItem('communityId');

                if (!communityId) return undefined;

                this.props.getALLResidentsByCommunityIDPagination(communityId, this.state.currentPage);
            });
        }
        this.setState({ residents: this.props.residentData })


        const t11 = setTimeout(() => {
            this.setState({ residents: this.props.residentData })


        }, 800);

        this.pushTimeouts(t11);

        window.addEventListener("resize", this.resize.bind(this));
        this.resize();
    };

    componentWillUnmount() {
        window.addEventListener("resize", this.resize.bind(this));

        if (this.state.timeouts) {
            this.state.timeouts.forEach(
                (timeout) => {
                    clearTimeout(timeout);
                }
            );
        }

    }

    resize() {
        this.setState({ isMobile: window.innerWidth <= 960 });
        const sizes = {
            xs: {
                name: 'xs',
                fontSize: '58%',
                maxWidht: 600,
            },
            sm: {
                name: 'sm',
                fontSize: '60%',
                maxWidht: 960,
            },
            md: {
                name: 'md',
                fontSize: '80%',
                maxWidht: 1280,
            },
            lg: {
                name: 'lg',
                fontSize: '100%',
                maxWidht: 1920,
            },

        };

        const windowWidth = window.innerWidth;

        let rootFontSize = sizes.xs;

        if (windowWidth > sizes.md.maxWidht) {
            rootFontSize = sizes.lg;
        } else if (windowWidth > sizes.sm.maxWidht) {
            rootFontSize = sizes.md;
        } else if (windowWidth > sizes.xs.maxWidht) {
            rootFontSize = sizes.sm;
        } else {
            rootFontSize = sizes.xs;
        }

        this.setState({ rootFontSize: rootFontSize });
    };


    //This methos is responsable to handle the click in cancel button
    //it does set state prop OPEN to false so in a rerender this component will not be render (it render the list of issues)
    //set the prop itemsByissue to []
    handleCancel = () => {
        if (this.state.open) {
            this.setState({ open: false });
            this.props.closeDialog();
        }
    };

    //This method handle the click in save button and depending on if state._id is defined it call method update else it call add method
    //and call closeDialog send as a property by Issue.jsx
    onSubmitHandler = (formData) => {

        this.state.modalnewResidentArray.forEach(resident => {
            this.AddNewResidentsInAPI(resident);
        });

        this.AddResidentToCommunity();

        this.cleanModal();
        delete formData.modalNewResidentTags


        this.props.closeDialog();
    };


    //Add users that are in residents list to the community resident list
    AddResidentToCommunity = () => {
        const residentArray = this.props.residentData ? this.props.residentData : [];
        const communityResidents = (this.props.data && this.props.data.residents) ? this.props.data.residents : [];
        const communityResidentsIds = communityResidents.map(resident => resident.residentId);


        let residentsNeddedToAdd = [];
        if (Array.isArray(residentArray) && Array.isArray(communityResidents)) {
            residentArray.forEach(
                item => {
                    const resident = communityResidentsIds.indexOf(item._id);

                    if (resident === -1) {
                        residentsNeddedToAdd.push(item);
                    }
                }
            );
        }


        residentsNeddedToAdd.forEach(
            item => {
                let putUserObject = {}
                let putResidentById = {}
                putResidentById.residentId = item._id;
                putResidentById.name = item.firstName + ' ' + item.lastName;
                putResidentById.residentPictureUrl = item.pictureUrl;
                putResidentById.zoneName = item.zoneName;
                putUserObject.users = putResidentById;

                this.props.PutUserByCommunity(item.communityId, putUserObject)
            }
        );

    };



    //#region Modal
    Modal = {
        hiddenButton: {
            display: 'none',
            marginLeft: '10px'
        },
        visibleButton: {
            marginTop: '10px',
            marginLeft: '10px',
            width: '156px'
        },
        visibleOutlinedButton: {
            marginTop: '10px',
            marginLeft: '10px',
            border: '1px solid #52bbe5',
            color: '#52bbe5',
            width: '7rem'

        },
        visibleDisabledButton: {
            marginTop: '10px',
            marginLeft: '10px',
            backgroundColor: '#ffffff',
            color: 'red',
            width: '7rem',
            border: '1px solid blue'
        }
    }


    handlerOnModalChipDelete = (chipText) => {
        let newChipArray = this.state.modalChipsArray;
        const index = newChipArray.indexOf(chipText);


        if (index !== -1) {
            newChipArray.splice(index, 1);
            this.setState({ modalChipsArray: newChipArray })
        }

    };

    handleOnClickModalAddButton = () => {
        const newTag = this.state.modalNewTagText;
        const ModalNewChipsArray = this.state.modalChipsArray;
        const index = ModalNewChipsArray.indexOf(newTag);

        if (ModalNewChipsArray.length < 10) {
            if (newTag.length <= 25) {
                if (index === -1 && newTag.length > 0) {
                    ModalNewChipsArray.push(newTag);

                    this.setState({ modalChipsArray: ModalNewChipsArray, modalNewTagText: '' });
                }
            } else {
                const message = 'The tag should contain less than 25 characters';
                GeneralAlert('error', message);
            }
        }
        else {
            const message = 'Can´t add more than 10 tags per resident';
            GeneralAlert('error', message);
        }
        this.props.dispatch(change('EditResidentForm', 'modalNewResidentTags', ''));



    };

    cleanModal = () => {
        this.setState({
            openModal: false,
            activeStep: 0,
            modalNewTagText: '',
            modalChipsArray: [],
            modalFirstName: '',
            modalLastName: '',
            modalLocation: '',
            modalBirthDay: undefined,
            modalnewResidentArray: [],
            onErrorModalFirstName: false,
            onErrorModalLastName: false,
            onErrorModalLocation: false,
            onErrorModalBirthDay: false,
            commonName: '',
            //clear resident
            residentUpdatePicture: null,
            residentPictureType: null,
            residentPictureName: null,
            residentPictureFile: null,
            //ResidentImage
            selectedResidentImage: 'https://engage360.s3.amazonaws.com/Residents/profile.png',
            objBase64selectedResidentImage: undefined,

            //Additional info

            //Marital status
            maritalStatusOptionsSelected: undefined,
            openMaritalStatus: false,


            //Wedding anniversary
            dateFormatAnniversary: 'MMMM dd, yyyy',
            weddingAnniversary: undefined,

            //Veteran
            veteranComponentOptionSelected: undefined,
            openVeteranComponent: false,

            //MoveIn Date
            moveInDate: undefined,
            dateFormatMoveIn: 'MMMM dd, yyyy',

            //Sex component
            sexOptionSelected: undefined,
            openSexComponent: undefined,

            //Engage Preference
            openEngagePreferenceComponent: false,
            engagePreferenceOptionSelected: undefined,

            //spirituality
            spiritualityOptionSelected: undefined,
            openSpiritualityComponent: false,

            //Language
            openLanguageComponent: false,
            languageOptionSelected: undefined,

            //children
            children: false,
            childrenQty: undefined,

            //grandchildren
            grandchildren: false,
            grandChildrenQty: undefined,

            //service of branch
            serviceBranchOptionSelected: undefined,

            //eHubInitiationDate
            eHubInitiationDate: undefined,
            dateFormatEhubInitiationDate: 'MMMM dd, yyyy',

            //normal wake time
            normalWakeTime: undefined,

            // normal bed time
            normalBedTime: undefined,
        });

    };


    handleAddResident = () => {
        if (!(this.state.onErrorModalFirstName || this.state.onErrorModalLastName || this.state.onErrorModalBirthDay)) {
            this.createNewResident();
            this.cleanModal();
            setTimeout(() => {
                this.setState({ residents: (this.state.filterObj) ? this.GetFilteredResidents(this.state.filterObj) : this.props.residentData });

            }, 1000);
        }
    };

    async createNewResident() {

        const newResident = {}
        newResident.name = this.state.modalFirstName + ' ' + this.state.modalLastName;
        newResident.createdAt = new Date();
        newResident.updatedAt = new Date();
        newResident.active = true;
        newResident.residentId = 0;
        newResident.communityId = this.state._id ? this.state._id : 0;
        newResident.zoneName = this.state.modalLocation;
        newResident.tags = this.state.modalChipsArray;
        newResident.firstName = this.state.modalFirstName;
        newResident.lastName = this.state.modalLastName;
        newResident.birthday = this.state.modalBirthDay;

        newResident.picture = {};
        if (!this.state.residentUpdatePicture)
            newResident.pictureUrl = 'https://engage360.s3.amazonaws.com/Residents/profile.png';
        else {
            newResident.picture.type = this.state.residentPictureType;
            newResident.picture.name = this.state.residentPictureName;
            newResident.picture.file = this.state.residentPictureFile;
        }
        this.state.modalnewResidentArray.push(newResident);

        //Details Image

        //  let objImage = {};
        // if((this.state.objBase64selectedDetailsImage)  && this.state.selectedDetailsImage){
        //     //Call Update Image to Server Await
        //     objImage = await this.props.AddDetailsImage(this.state.objBase64selectedDetailsImage)
        //     newResident.pictureUrl = objImage.url;
        // }

        this.AddNewResidentsInAPI(newResident);

        const t5 = setTimeout(() => {
            this.AddResidentToCommunity();
        }, 1000);

        this.pushTimeouts(t5);

        this.cleanModal();
    };

    AddNewResidentsInAPI = (resident) => {
        //Add resident Action
        let newResident = {};

        newResident.tags = resident.tags;
        newResident.firstName = resident.firstName;
        newResident.lastName = resident.lastName;
        newResident.communityId = resident.communityId;
        newResident.zoneName = resident.zoneName;
        newResident.birthday = resident.birthday;
        newResident.commonName = this.state.commonName ? this.state.commonName : undefined;

        //Aditional information
        newResident.moveDate = this.state.moveInDate ? this.state.moveInDate : undefined;
        newResident.weddingAnniversary = this.state.weddingAnniversary ? this.state.weddingAnniversary : undefined;
        newResident.sex = (this.state.sexOptionSelected && this.state.sexOptionSelected.name) ? this.state.sexOptionSelected.name : undefined;
        newResident.relationshipStatus = (this.state.maritalStatusOptionsSelected && this.state.maritalStatusOptionsSelected.name) ? this.state.maritalStatusOptionsSelected.name : undefined;
        newResident.children = (this.state.children) ? this.state.children : false;
        newResident.childrenQty = (this.state.childrenQty) ? Number(this.state.childrenQty) : undefined;
        newResident.granchildren = (this.state.grandchildren) ? this.state.grandchildren : false;
        newResident.granchildrenQty = (this.state.grandChildrenQty) ? Number(this.state.grandChildrenQty) : undefined;
        newResident.spiritual = (this.state.spiritualityOptionSelected && this.state.spiritualityOptionSelected.name) ? this.state.spiritualityOptionSelected.name : undefined;
        newResident.preferedLanguage = (this.state.languageOptionSelected && this.state.languageOptionSelected.name) ? this.state.languageOptionSelected.name : undefined;
        newResident.veteran = (this.state.veteranComponentOptionSelected && this.state.veteranComponentOptionSelected.name) ? this.state.veteranComponentOptionSelected.name : undefined;
        newResident.serviceBranch = (this.state.serviceBranchOptionSelected && this.state.serviceBranchOptionSelected.name) ? this.state.serviceBranchOptionSelected.name : undefined;
        newResident.engagePreference = (this.state.engagePreferenceOptionSelected && this.state.engagePreferenceOptionSelected.name) ? this.state.engagePreferenceOptionSelected.name : undefined;
        newResident.eHubInitiationDate = (this.state.eHubInitiationDate) ? this.state.eHubInitiationDate : undefined;
        newResident.normalWakeTime = (this.state.normalWakeTime) ? this.state.normalWakeTime : undefined;
        newResident.normalBedTime = (this.state.normalBedTime) ? this.state.normalBedTime : undefined;
        newResident.languageCode = 'en'

        if (!this.state.residentUpdatePicture) {
            newResident.pictureUrl = resident.pictureUrl;
        } else {
            newResident.picture = {};
            newResident.picture.type = resident.picture.type;
            newResident.picture.name = resident.picture.name;
            newResident.picture.file = resident.picture.file;
        }

        switch (this.state.languageOptionSelected?.name) {
            case 'Spanish':
                newResident.languageCode = 'es'
                break;
            case 'French':
                newResident.languageCode = 'fr'
                break;
            case 'English':
                newResident.languageCode = 'en'
                break;
            default:
                newResident.languageCode = 'en'
                break;
        }

        this.props.AddResident(newResident, localStorage.getItem('communityId'));
    };
    //#endregion

    //#region Resident Update

    inputHidden = {
        display: 'none'
        // displayComponent: 'none'
    }

    handleOpenResidentForm = (residentInput) => {

        const residentId = residentInput._id;
        let resident = undefined;
        let activesFamilyMembers = undefined;

        if (residentId && this.props.residentData) {
            resident = this.props.residentData.find(item => item._id === residentId)
        }

        if (resident) {

            const firstName = resident.firstName ? resident.firstName : '';
            const lastName = resident.lastName ? resident.lastName : '';
            const location = resident.zoneName ? resident.zoneName : '';
            const birthday = resident.birthday ? resident.birthday : undefined;
            const identifiers = resident.tags ? [...resident.tags] : [];
            const pictureUrl = resident.pictureUrl ? resident.pictureUrl : '';
            const devices = resident.devices ? [...resident.devices] : [];
            const familyMembers = resident.familyMembers ? [...resident.familyMembers] : [];

            const weddingAnniversary = resident.weddingAnniversary ? resident.weddingAnniversary : undefined;
            const moveDate = resident.moveDate ? resident.moveDate : undefined;
            const veteran = resident.veteran ? resident.veteran : undefined;
            const serviceBranch = resident.serviceBranch ? resident.serviceBranch : undefined;
            const sex = resident.sex ? resident.sex : undefined;
            const children = resident.children ? resident.children : false;
            const childrenQty = resident.childrenQty ? resident.childrenQty : undefined;
            const granchildren = resident.granchildren ? resident.granchildren : false;
            const granchildrenQty = resident.granchildrenQty ? resident.granchildrenQty : undefined;
            const preferedLanguage = resident.preferedLanguage ? resident.preferedLanguage : undefined;
            const relationshipStatus = resident.relationshipStatus ? resident.relationshipStatus : undefined;
            const spiritual = resident.spiritual ? resident.spiritual : undefined;
            const engagePreference = resident.engagePreference ? resident.engagePreference : undefined;
            const eHubInitiationDate = resident.eHubInitiationDate ? resident.eHubInitiationDate : undefined;
            const normalWakeTime = resident.normalWakeTime ? resident.normalWakeTime : undefined;
            const normalBedTime = resident.normalBedTime ? resident.normalBedTime : undefined;
            const commonName = resident.commonName ? resident.commonName : undefined;


            this.props.handleIsUpdResident(true);

            if (familyMembers.length > 0)
                activesFamilyMembers = familyMembers.filter(familiar => familiar.active === true);

            this.setState({
                isUpdResident: true,
                residentSelected: { ...resident },
                selectedResidentFirstName: firstName,
                selectedResidentLastName: lastName,
                selectedResidentLocation: location,
                selectedResidentBirthday: birthday,
                selectedResidentIdentifiers: identifiers,
                selectedResidentDevices: devices,
                selectedResidentFamilyMembers: activesFamilyMembers ? activesFamilyMembers : [],
                selectedResidentPictureUrl: pictureUrl ? pictureUrl : 'https://engage360.s3.amazonaws.com/Residents/profile.png',

                veteranComponentOptionSelected: { name: veteran },
                serviceBranchOptionSelected: { name: serviceBranch },
                children: children,
                grandchildren: granchildren,
                childrenQty: childrenQty,
                grandChildrenQty: granchildrenQty,
                sexOptionSelected: { name: sex },
                maritalStatusOptionsSelected: { name: relationshipStatus },
                spiritualityOptionSelected: { name: spiritual },
                languageOptionSelected: { name: preferedLanguage },
                moveInDate: moveDate,
                weddingAnniversary: weddingAnniversary,
                engagePreferenceOptionSelected: { name: engagePreference },
                eHubInitiationDate: eHubInitiationDate,
                normalWakeTime: normalWakeTime,
                normalBedTime: normalBedTime,
                commonName: commonName,
                isVoiceAvailable: residentInput.isVoiceAvailable === null ? undefined : residentInput.isVoiceAvailable
            });
        }
    };

    handlerOnResidentFormChipDelete = (chipText) => {
        let newChipArray = this.state.selectedResidentIdentifiers;
        const index = newChipArray.indexOf(chipText);


        if (index !== -1) {
            newChipArray.splice(index, 1);
            this.setState({ selectedResidentIdentifiers: newChipArray })
        }
    };

    handleOnClickResidentFormAddButton = () => {
        const newTag = this.state.selectedResidentTagText;
        const ModalNewChipsArray = this.state.selectedResidentIdentifiers ? [...this.state.selectedResidentIdentifiers] : [];
        const index = ModalNewChipsArray.indexOf(newTag);


        if (ModalNewChipsArray.length < 10) {

            if (newTag.length <= 25) {
                if (index === -1 && newTag.length > 0) {
                    ModalNewChipsArray.push(newTag);

                    this.setState({
                        selectedResidentTagText: '',
                        selectedResidentIdentifiers: ModalNewChipsArray,
                    });
                }
            }
            else {
                const message = 'The identifier should contain less than 25 characters';
                sweetAlert('error', message, 'alert_AddEditResident_MaxCharacters_Error');
                this.setState({ selectedResidentTagText: '' })
            }
        } else {
            const message = 'Can´t add more than 10 identifiers per resident';
            sweetAlert('error', message, 'alert_AddEditResident_Indentifiers_Error');
        }

        this.props.dispatch(change('EditResidentForm', 'residentFormIdentifiers', ''));
    };

    handlerEditResident = async () => {
        let residentUpdated = this.state.residentSelected;

        residentUpdated.firstName = this.state.selectedResidentFirstName;
        residentUpdated.lastName = this.state.selectedResidentLastName;
        residentUpdated.zoneName = this.state.selectedResidentLocation;
        residentUpdated.birthday = this.state.selectedResidentBirthday;
        residentUpdated.commonName = this.state.commonName;
        residentUpdated.tags = this.state.selectedResidentIdentifiers;
        residentUpdated.picture = {};

        residentUpdated.isVoiceAvailable = this.state.isVoiceAvailable === undefined ? null : this.state.isVoiceAvailable;

        //Aditional information
        residentUpdated.moveDate = this.state.moveInDate ? this.state.moveInDate : undefined;
        residentUpdated.weddingAnniversary = this.state.weddingAnniversary ? this.state.weddingAnniversary : undefined;
        residentUpdated.sex = (this.state.sexOptionSelected && this.state.sexOptionSelected.name) ? this.state.sexOptionSelected.name : undefined;
        residentUpdated.relationshipStatus = (this.state.maritalStatusOptionsSelected && this.state.maritalStatusOptionsSelected.name) ? this.state.maritalStatusOptionsSelected.name : undefined;
        residentUpdated.children = (this.state.children) ? this.state.children : false;
        residentUpdated.childrenQty = (this.state.childrenQty) ? Number(this.state.childrenQty) : undefined;
        residentUpdated.granchildren = (this.state.grandchildren) ? this.state.grandchildren : false;
        residentUpdated.granchildrenQty = (this.state.grandChildrenQty) ? Number(this.state.grandChildrenQty) : undefined;
        residentUpdated.spiritual = (this.state.spiritualityOptionSelected && this.state.spiritualityOptionSelected.name) ? this.state.spiritualityOptionSelected.name : undefined;
        residentUpdated.preferedLanguage = (this.state.languageOptionSelected && this.state.languageOptionSelected.name) ? this.state.languageOptionSelected.name : undefined;
        residentUpdated.veteran = (this.state.veteranComponentOptionSelected && this.state.veteranComponentOptionSelected.name) ? this.state.veteranComponentOptionSelected.name : undefined;
        residentUpdated.serviceBranch = (this.state.serviceBranchOptionSelected && this.state.serviceBranchOptionSelected.name) ? this.state.serviceBranchOptionSelected.name : undefined;
        residentUpdated.engagePreference = (this.state.engagePreferenceOptionSelected && this.state.engagePreferenceOptionSelected.name) ? this.state.engagePreferenceOptionSelected.name : undefined;
        residentUpdated.eHubInitiationDate = (this.state.eHubInitiationDate) ? this.state.eHubInitiationDate : undefined;
        residentUpdated.normalWakeTime = (this.state.normalWakeTime) ? this.state.normalWakeTime : undefined;
        residentUpdated.normalBedTime = (this.state.normalBedTime) ? this.state.normalBedTime : undefined;
        residentUpdated.languageCode = 'en'

        if (!this.state.residentUpdatePicture) {
            residentUpdated.pictureUrl = this.state.selectedResidentPictureUrl;
        } else {
            residentUpdated.picture.type = this.state.residentPictureType;
            residentUpdated.picture.name = this.state.residentPictureName;
            residentUpdated.picture.file = this.state.residentPictureFile;
        }

        switch (this.state.languageOptionSelected?.name) {
            case 'Spanish':
                residentUpdated.languageCode = 'es'
                break;
            case 'French':
                residentUpdated.languageCode = 'fr'
                break;
            case 'English':
                residentUpdated.languageCode = 'en'
                break;
            default:
                residentUpdated.languageCode = 'en'
                break;
        }

        await this.props.UpdResident(residentUpdated._id, residentUpdated, localStorage.getItem('communityId'));

        const t4 = setTimeout(() => {
            if (this.props.data._id) {
                this.props.getResidentsByCommunity(this.props.data._id);
            }
        }, 600);

        this.pushTimeouts(t4);

        this.handleCancelUpdateResident();

        this.cleanModal();

    };

    handlerDeleteResident = async () => {
        const idDelete = this.state.residentSelected._id
        const title = 'Are you sure you want to delete the resident?';
        const { isConfirmed } = await SweetConfirmationAlert(title, 'alert_deleteResident');

        if (isConfirmed) {
            this.deleteResident({}, idDelete);

            setTimeout(() => {
                this.setState({ residents: (this.state.filterObj) ? this.GetFilteredResidents(this.state.filterObj) : this.props.residentData });

            }, 300);

        }
    };

    deleteResident = (event, idDelete) => {

        this.props.DelResident(idDelete);
        this.handleCancelUpdateResident();

        Alert.closeAll();
    }

    handleCancelUpdateResident = async () => {



        if (this.props.data._id) {
            setTimeout(() => {
                this.props.getResidentsByCommunity(this.props.data._id)
            }, 100);
        }

        setTimeout(() => {
            this.setState({ isUpdResident: false, residentSelected: undefined, residents: (this.state.filterObj) ? this.GetFilteredResidents(this.state.filterObj) : undefined });
            this.props.handleIsUpdResident(false);
        }, 200);

        //this.props.closeDialog();
    };

    divImageClick = () => {
        //this.refs.fileUploader.click();
        document.getElementById("loadImage").click();
    }

    //#endregion


    //#region methods
    Capitalize = (s) => {
        if (typeof s !== 'string') {
            return ''
        } else {


            let newString = s; //.toLocaleLowerCase();
            let namesArray = newString.split(' ');

            const capitalizedNamesArray = namesArray.map(
                (name) => {
                    return name.charAt(0).toUpperCase() + name.slice(1)
                }
            );
            return capitalizedNamesArray.join(' ');
        }
    };

    CheckForValidCaracters = (input, validationType) => {
        let pattern = '^[a-zA-Z0-9\\s_&ñÑáÁàÀäÄâÂçÇéÉëËèÈêÊíÍïÏìÌîÎóÓöÖòÒôÔúÚüÜùÙûÛÿ.\'-]*$';

        if (input.length > 0) {
            var regex = new RegExp(pattern);
            if (regex.test(input)) {
                return input;
            } else {
                return input.substring(0, input.length - 1);
            }
        } else {
            return input;
        }

    };

    isOnError = (field) => {

        switch (field.toLocaleLowerCase()) {
            case 'firstname':
                this.setState({ onErrorModalFirstName: (this.state.modalFirstName === '') });
                break;
            case 'lastname':
                this.setState({ onErrorModalLastName: (this.state.modalLastName === '') });
                break;
            case 'location':
                this.setState({ onErrorModalLocation: (this.state.modalLocation === '') });
                break;
            case 'birthday':
                this.setState({ onErrorModalBirthDay: (this.state.modalBirthDay === undefined) });
                break;
            case 'selectedresidentfirstname':
                this.setState({ onErrorSelectedResidentFirstName: (this.state.selectedResidentFirstName === '') });
                const t2 = setTimeout(() => {
                    this.props.handlerOnErrorFirstName(this.state.onErrorSelectedResidentFirstName)
                }, 50);

                this.pushTimeouts(t2);
                break;
            case 'selectedresidentlastname':
                this.setState({ onErrorSelectedResidentLastName: (this.state.selectedResidentLastName === '') });
                const t3 = setTimeout(() => {
                    this.props.handlerOnErrorLastName(this.state.onErrorSelectedResidentLastName)
                }, 50);
                this.pushTimeouts(t3);
                break;
            default: break;

        }
    };

    GetUTCDate = (date) => {
        let isoDate = new Date();

        if (this.props.data && this.props.data.timeZoneName) {

        }
        isoDate = new Date(date).toISOString();
        return isoDate;
    };

    GetLocalTimeFromUTC = (isoDate) => {
        const localTime = new Date(isoDate);

        return localTime;
    };

    DateValidation = (date, type) => {

    }

    readImage(e, imageName) {
        //Base 64


        let reader = new FileReader();
        const imageSelected = e.target.files[0]

        if (imageSelected === undefined)
            return;

        reader.readAsDataURL(e.target.files[0]);
        reader.onloadend = () => {
            const objBase64 = {
                type: imageSelected.type,
                name: imageSelected.name.replace(/[:/#?&@%+~\s]/g, '_'),
                file: reader.result

            }



            switch (imageName) {
                case 'residentImage':
                    this.setState({
                        residentPictureType: imageSelected.type,
                        residentPictureName: imageSelected.name.replace(/[:/#?&@%+~\s]/g, '_'),
                        selectedResidentImage: URL.createObjectURL(imageSelected),
                        objBase64selectedResidentImage: objBase64,
                        residentPictureFile: reader.result,
                        residentUpdatePicture: true
                    });
                    break;

                case 'selectedResidentImage':
                    this.setState({
                        selectedResidentPictureUrl: URL.createObjectURL(imageSelected),
                        residentPictureType: imageSelected.type,
                        residentPictureName: imageSelected.name.replace(/[:/#?&@%+~\s]/g, '_'),
                        residentPictureFile: reader.result,
                        residentUpdatePicture: true
                    });

                    break;
                default:
                    break;
            }


        }
    };

    GetResidentInitial(firstName, lastName) {

        return firstName.substring(0, 1).toUpperCase() + lastName.substring(0, 1).toUpperCase();
    };


    //#region InvitationModal
    InvitationModal = () => {
        this.setState({ openConnectInvitationModal: true });
    }

    SyncResidents = () => {
        this.props.SyncResidentsByCommunity(localStorage.getItem('communityId'))
    }


    handleDelete = async (e, data, index) => {
        if (data) {

            const title = `Are you sure you want to block the family member "${data.name}" in the Connect App?`;

            const { isConfirmed } = await SweetConfirmationAlert(title, 'alert_blockFamilyMember');

            if (isConfirmed) {
                this.blockFamiliar({}, data);
            }

        }
    }

    blockFamiliar = (event, item) => {
        Alert.closeAll();
        this.props.BlockFamiliar(item.familyMemberId);

        let residentId = this.state.residentSelected._id;

        const t0 = setTimeout(() => {
            if (this.props.data._id) {
                this.props.getResidentsByCommunity(this.props.data._id);
            }
        }, 300);

        this.pushTimeouts(t0);


        const t1 = setTimeout(() => {
            if (this.props.data._id) {
                this.handleOpenResidentForm(this.props.residentData.find(resident => resident._id === residentId));
            }
        }, 600);

        this.pushTimeouts(t1);

    };
    //#endregion


    changeDateFormat = (dateFormat) => {
        if (dateFormat) {
            this.setState({ dateFormat: dateFormat });
        }
    }

    deleteResidentImage = () => {
        this.setState({ selectedResidentPictureUrl: 'https://engage360.s3.amazonaws.com/Residents/profile.png' })
    }

    sortResidents = () => {
        if ((this.props.residentData && this.props.residentData.length > 0) || (this.state.residents && this.state.residents.length > 0)) {
            this.state.residents ?
                this.state.residents.reverse()
                :
                this.props.residentData &&
                this.props.residentData.reverse()

        }
    }

    openFilters = () => {
        this.setState({
            openFilters: this.props.openFilters,
            AnchorElId: this.props.filtersAnchorElId

        });
    }

    onFilterChange = (filterObj) => {

        if (filterObj) {
            //let residentsFiltered = this.GetFilteredResidents(filterObj);

            this.setState({
                filterObj: filterObj,
                // residents: residentsFiltered
            });

        }

    }

    GetFilteredResidents = (filterObj) => {

        let residents = [...this.props.residentData];

        let residentsFiltered = undefined;

        residentsFiltered = residents;

        if (filterObj) {

            if (filterObj.nameFilter) {
                residentsFiltered = residentsFiltered.filter(item => item.firstName.trim() === filterObj.nameFilter.trim());
            }
            if (filterObj.lastNameFilter) {
                residentsFiltered = residentsFiltered.filter(item => item.lastName.trim() === filterObj.lastNameFilter.trim());
            }
            if (filterObj.zoneNameFilter) {
                residentsFiltered = residentsFiltered.filter(item => item.zoneName.trim() === filterObj.zoneNameFilter.trim());
            }
        }

        return residentsFiltered;


    }

    applyFilters = () => {
        const residentsFiltered = this.GetFilteredResidents(this.state.filterObj)
        this.setState({ residents: residentsFiltered })
    }

    resetFilters = () => {
        this.setState({ filterObj: undefined, residents: this.props.residentData })
    }


    GetNumberValidated = (string, type) => {
        try {
            const newItem = string.trim();
            if (!newItem || newItem === '') {
                return '';
            }

            const regex = new RegExp('^\\d*$');

            let initialValue = undefined;
            let itemValidated = undefined;

            switch (type) {
                case 'children':
                    initialValue = this.state.childrenQty ? this.state.childrenQty : '';
                    itemValidated = regex.test(newItem) ? newItem : initialValue;

                    break;
                case 'grandchildren':
                    initialValue = this.state.grandChildrenQty ? this.state.grandChildrenQty : '';
                    itemValidated = regex.test(newItem) ? newItem : initialValue;

                    break;
                default:
                    itemValidated = undefined;
                    break;
            }

            return itemValidated;
        } catch (err) { }
    }

    GetValidTime = (date, fieldName) => {
        const d = new Date(date).toString().toLowerCase();
        let provisionalDate = undefined;

        //If the date is invalid then returns the latest date in the field
        if (d === 'invalid date') {
            switch (fieldName) {
                case 'normalWakeTime':
                    //this.setState({breakfastStart: date});
                    provisionalDate = this.state.normalWakeTime;
                    break;
                case 'normalBedTime':
                    //this.setState({breakfastEnd: date});
                    provisionalDate = this.state.normalBedTime;
                    break;
                default:
                    break;
            }
        } else {
            provisionalDate = d;
        }
        //Get Valid end Time 
        // switch(fieldName){
        //     case 'normalBedTime':
        //         provisionalDate = this.GetValidEndDate( this.state.breakfastStart ? this.state.breakfastStart : new Date(), provisionalDate) ;
        //         break;
        //     case 'normalWakeTime':
        //         provisionalDate = this.GetValidEndDate( this.state.lunchStart ? this.state.lunchStart : new Date(), provisionalDate) ;
        //         break;
        //     default:
        //         break;
        // }

        return provisionalDate;
    };

    // GetValidEndDate(startDate , endDate){
    //     if(startDate > endDate){
    //         const message = 'The start time of the meal cannot be greater than the end time'
    //         sweetAlert('error',message);
    //         return startDate;
    //     }else{
    //         return endDate;
    //     }
    // }



    //INNER COMPONENTS
    //#region AgeComponent
    AgeComponent = () => {
        try {
            const isUpdate = this.state.isUpdResident ? true : false;
            const now = new Date();
            let bd = new Date()

            if (isUpdate) {

                bd = (this.state.selectedResidentBirthday) ? new Date(this.state.selectedResidentBirthday) : new Date();
            } else {
                bd = this.state.modalBirthDay ? new Date(this.state.modalBirthDay) : new Date();
            }


            let Age = now.getFullYear() - bd.getFullYear();
            const month = now.getMonth() - bd.getMonth();

            if (month < 0 || (month === 0 && now.getDate() < bd.getDate())) {
                Age = Age - 1;
            }

            return (
                <Grid item container xs={12}>
                    {
                        Age && Age > 0 ?
                            <TextField
                                id='addEditResdient_AgeComponent'
                                label={'Age'}
                                disabled={true}
                                className="newTextFielStyles contentModal"
                                value={Age}
                            />
                            :
                            undefined
                    }
                </Grid>
            )
        } catch (err) {
            return <Grid item container xs={12}></Grid>
        }
    }
    //#endregion

    //#region veteran component
    onBlurVeteranHandler = () => {
        this.setState({ openVeteranComponent: false })
    }

    VeteranComponentOpenHandler = () => {

        this.setState((prevState) => ({ openVeteranComponent: !prevState.openVeteranComponent }));
    }

    VeteranComponentChangeHandler = (newItem) => {
        try {
            this.setState(
                { veteranComponentOptionSelected: newItem },
                () => this.setState({ openVeteranComponent: false })
            );

            this.props.dispatch(change('EditResidentForm', 'veteranComponent', newItem))

        } catch (err) {

        }
    };

    VeteranComponent = () => {
        try {
            const veteranArray = ["Yes", "No", "Prefer not to answer"];
            const veteranOptionsArray = veteranArray.map((option) => ({ name: option }));

            return (
                <Grid item xs={12} className="contentModal" >
                    <Field
                        idToSet="resident_veteran"
                        name="veteranComponent"
                        label="Veteran"
                        maxLength={20}
                        selected={this.state.veteranComponentOptionSelected ? this.state.veteranComponentOptionSelected : { name: '' }}
                        onChangeHandler={(evet, newItem) => this.VeteranComponentChangeHandler(newItem)}
                        optionsItemsIconsData={veteranOptionsArray ? veteranOptionsArray : []}
                        open={this.state.openVeteranComponent ? this.state.openVeteranComponent : false}
                        onClick={this.VeteranComponentOpenHandler}
                        onBlur={this.onBlurVeteranHandler}
                        component={renderSelect}
                    />
                </Grid>
            )
        } catch (err) { }
    };

    //#endregion

    //#region  Marital status component
    onBlurMaritalStatusHandler = () => {
        this.setState({ openMaritalStatus: false })
    }

    handleMaritalStatusCombo = () => {

        this.setState((prevState) => ({ openMaritalStatus: !prevState.openMaritalStatus }));
    }

    maritalStatusOnChangeHandler = (newItem) => {
        try {
            this.setState(
                { maritalStatusOptionsSelected: newItem },
                () => this.setState({ openMaritalStatus: false })
            );

            this.props.dispatch(change('EditResidentForm', 'MaritalStatusComponent', newItem))
        } catch (err) {

        }
    };

    MaritalStatusComponent = () => {
        const maritalStatusArray = ["Married", "Divorced", "Single", "Widow/Widowed"];
        const maritalStatusObjArray = maritalStatusArray.map(status => ({ name: status }));

        try {
            return (
                <Grid item xs={12} className="contentModal" >
                    <Field
                        idToSet='residents_marital_status'
                        name="MaritalStatusComponent"
                        label="Marital Status"
                        maxLength={20}
                        selected={this.state.maritalStatusOptionsSelected ? this.state.maritalStatusOptionsSelected : { name: '' }}
                        onChangeHandler={(evet, newItem) => this.maritalStatusOnChangeHandler(newItem)}
                        optionsItemsIconsData={maritalStatusObjArray ? maritalStatusObjArray : []}
                        open={this.state.openMaritalStatus ? this.state.openMaritalStatus : false}
                        onClick={this.handleMaritalStatusCombo}
                        onBlur={this.onBlurMaritalStatusHandler}
                        component={renderSelect}
                    />
                </Grid>
            )
        } catch (err) {

        }
    };
    //#endregion

    //#region  WeedingAnniversary
    changeDateFormatAnniversary = (dateFormat) => {
        if (dateFormat) {
            this.setState({ dateFormatAnniversary: dateFormat });
        }
    };

    WeddingAnniversaryComponent = () => {
        try {
            return (
                <Grid item xs={12} className="contentModal">
                    <Field
                        idToSet="resident_wedding_aniversary"
                        labelDate="Wedding Anniversary  Date"
                        selectedDate={this.state.weddingAnniversary} //most be an date object is use in both date and time
                        fieldFocus={() => this.changeDateFormatAnniversary('MM/dd/yyyy')}
                        fieldBlur={() => this.changeDateFormatAnniversary('MMMM dd, yyyy')}
                        dateFormat={this.state.dateFormatAnniversary}
                        isFieldFocused={this.state.dateFormatAnniversary === 'MM/dd/yyyy'}
                        disabledDates={{ maxDate: new Date() }}
                        onDateChange={(date) => {

                            let dateChanged = date === null ? new Date() : date;
                            if (dateChanged > new Date()) {
                                const message = 'The birth date must be in the past'
                                sweetAlert('error', message, 'alert_AddEditResident_FutureBirthdate_Error');
                                this.setState({ weddingAnniversary: new Date() });
                            } else {

                                this.setState({ weddingAnniversary: date });
                            }
                        }}
                        maxLength={20}
                        component={renderSingleDateFormattedPicker}
                    />
                </Grid>
            );
        } catch (err) { }
    };
    //#endregion

    //#region  Move-in date
    changeDateFormatMoveIn = (dateFormat) => {
        if (dateFormat) {
            this.setState({ dateFormatMoveIn: dateFormat });
        }
    };

    MoveInDateComponent = () => {
        try {
            return (
                <Grid item xs={12} className="contentModal">
                    <Field
                        idToSet="resident_move_in_date"
                        labelDate="Move-in Date"
                        selectedDate={this.state.moveInDate} //most be an date object is use in both date and time
                        fieldFocus={() => this.changeDateFormatMoveIn('MM/dd/yyyy')}
                        fieldBlur={() => this.changeDateFormatMoveIn('MMMM dd, yyyy')}
                        dateFormat={this.state.dateFormatMoveIn}
                        isFieldFocused={this.state.dateFormatMoveIn === 'MM/dd/yyyy'}
                        disabledDates={{ maxDate: new Date() }}
                        onDateChange={(date) => {

                            this.setState({ moveInDate: date });
                        }
                        }
                        maxLength={20}
                        component={renderSingleDateFormattedPicker}
                    />
                </Grid>
            )
        } catch (err) { }
    };
    //#endregion

    //#region  ehub initiation date
    changeDateFormatEhubInitiationDate = (dateFormat) => {
        if (dateFormat) {
            this.setState({ dateFormatEhubInitiationDate: dateFormat });
        }
    };

    EhubInitiationDateComponent = () => {
        try {
            return (
                <Grid item xs={12} className="contentModal">
                    <Field
                        idToSet="ehub_initiation_date"
                        labelDate="EHub Initiaton Date"
                        selectedDate={this.state.eHubInitiationDate} //most be an date object is use in both date and time
                        fieldFocus={() => this.changeDateFormatEhubInitiationDate('MM/dd/yyyy')}
                        fieldBlur={() => this.changeDateFormatEhubInitiationDate('MMMM dd, yyyy')}
                        dateFormat={this.state.dateFormatEhubInitiationDate}
                        isFieldFocused={this.state.dateFormatEhubInitiationDate === 'MM/dd/yyyy'}
                        disabledDates={{ maxDate: new Date() }}
                        onDateChange={(date) => {
                            this.setState({ eHubInitiationDate: date });
                        }
                        }
                        maxLength={20}
                        component={renderSingleDateFormattedPicker}
                    />
                </Grid>
            )
        } catch (err) { }
    };
    //#endregion

    //#region normal wake time
    NormalWakeTimeComponent = () => {
        try {
            return (
                <Grid item container xs={12}>
                    <Field
                        idToSet='Resident_Normal_Wake_Time'
                        name="normalWakeTime"
                        label="Normal Wake Time"
                        fieldName={'normalWakeTime'}
                        selectedDate={this.state.normalWakeTime}
                        onDateChange={(e, fieldName) => this.setState({ normalWakeTime: this.GetValidTime(e, fieldName) })}
                        inputClass='EditResidentForm'
                        component={renderTimePicker}
                    />
                </Grid>
            )
        } catch (err) {
            return (
                <Grid item container xs={12}></Grid>
            )
        }
    };
    //#endregion

    //#region normal bed time
    NormalBedTimeComponent = () => {
        try {
            return (
                <Grid item container xs={12}>
                    <Field
                        idToSet='Resident_Normal_Bed_Time'
                        name="normalBedTime"
                        label="Normal Bed Time"
                        fieldName={'normalBedTime'}
                        selectedDate={this.state.normalBedTime}
                        onDateChange={(e, fieldName) => this.setState({ normalBedTime: this.GetValidTime(e, fieldName) })}
                        inputClass='EditResidentForm'
                        component={renderTimePicker}
                    />
                </Grid>
            )
        } catch (err) {
            return (
                <Grid item container xs={12}></Grid>
            )
        }
    };
    //#endregion

    //#region  Sex component
    openSexComponentHandler = () => {
        try {
            this.setState((prevState) => ({ openSexComponent: !prevState.openSexComponent }));
        } catch (err) { }
    };

    sexComponentOnChangeHandler = (newItem) => {
        try {

            this.setState(
                { sexOptionSelected: newItem },
                () => this.setState(
                    { openSexComponent: false }
                )
            );

            this.props.dispatch(change('EditResidentForm', 'sexcomponent', newItem))


        } catch (err) { }
    };

    onBlurSexComponentHandler = () => {
        try {
            this.setState({ openSexComponent: false })
        } catch (err) { }
    };

    SexComponent = () => {
        try {
            let sexArray = ["Male", "Female"];
            sexArray.sort().push('Prefer not to answer');
            const sexObjArray = sexArray.map((sex) => ({ name: sex }));

            return (
                <Grid item xs={12} className="contentModal">
                    <Field
                        name="sexcomponent"
                        label="Sex"
                        maxLength={20}
                        selected={this.state.sexOptionSelected ? this.state.sexOptionSelected : { name: '' }}
                        onChangeHandler={(evet, newItem) => this.sexComponentOnChangeHandler(newItem)}
                        optionsItemsIconsData={sexObjArray ? sexObjArray : []}
                        open={this.state.openSexComponent ? this.state.openSexComponent : false}
                        onClick={this.openSexComponentHandler}
                        onBlur={this.onBlurSexComponentHandler}
                        component={renderSelect}
                        idToSet='resident_sex'
                    />
                </Grid>
            )
        } catch (err) { }
    };
    //#endregion

    //#region  spiritual component
    openSpiritualityComponentHandler = () => {
        try {
            this.setState((prevState) => ({ openSpiritualityComponent: !prevState.openSpiritualityComponent }));
        } catch (err) { }
    };

    spiritualComponentOnChangeHandler = (newItem) => {
        try {

            this.setState(
                { spiritualityOptionSelected: newItem },
                () => this.setState({ openSpiritualityComponent: false })
            );

            this.props.dispatch(change('EditResidentForm', 'SpititualityComponent', newItem))

        } catch (err) { }
    };

    onBlurSpiritualityComponentHandler = () => {
        try {
            this.setState({ openSpiritualityComponent: false })
        } catch (err) { }
    };

    SpiritualityComponent = () => {

        let spiritualityArray = ["Christianity", "Islam", "No religion/Agnostic", "Hinduism", "Buddhism", "Folk religions", "Sikhism", "Judaism", "Atheism"];
        spiritualityArray.sort().push('Other');
        spiritualityArray.push('Prefer not to answer');

        const spiritualityOptionsArray = spiritualityArray.map((spirituality) => ({ name: spirituality }));

        try {
            return (
                <Grid item container xs={12} className="contentModal" >
                    <Field
                        idToSet="resident_spirituality"
                        name="SpititualityComponent"
                        label="Spitituality"
                        maxLength={20}
                        selected={this.state.spiritualityOptionSelected ? this.state.spiritualityOptionSelected : { name: '' }}
                        onChangeHandler={(evet, newItem) => this.spiritualComponentOnChangeHandler(newItem)}
                        optionsItemsIconsData={spiritualityOptionsArray ? spiritualityOptionsArray : []}
                        open={this.state.openSpiritualityComponent ? this.state.openSpiritualityComponent : false}
                        onClick={this.openSpiritualityComponentHandler}
                        onBlur={this.onBlurSpiritualityComponentHandler}
                        component={renderSelect}
                    />
                </Grid>
            )
        } catch (err) { }
    };
    //#endregion

    //#region language component
    openLanguageComponentHandler = () => {
        try {
            this.setState((prevState) => ({ openLanguageComponent: !prevState.openLanguageComponent }));
        } catch (err) { }
    };

    languageComponentOnChangeHandler = (newItem) => {
        try {

            this.setState(
                { languageOptionSelected: newItem },
                () => this.setState({ openLanguageComponent: false })
            );

            this.props.dispatch(change('EditResidentForm', 'LanguageComponent', newItem))
        } catch (err) { }
    };

    onBlurLanguageComponentHandler = () => {
        try {
            this.setState({ openLanguageComponent: false })
        } catch (err) { }
    };

    LanguageComponent = () => {
        try {
            const languageArray = ["English", "Spanish", "French", "Other"];
            const languageOptionsArray = languageArray.map((lan) => ({ name: lan }));

            return (
                <Grid item container xs={12} className="contentModal">
                    <Field
                        idToSet="resident_language"
                        name="LanguageComponent"
                        label="Language"
                        maxLength={20}
                        selected={this.state.languageOptionSelected ? this.state.languageOptionSelected : { name: '' }}
                        onChangeHandler={(evet, newItem) => this.languageComponentOnChangeHandler(newItem)}
                        optionsItemsIconsData={languageOptionsArray ? languageOptionsArray : []}
                        open={this.state.openLanguageComponent ? this.state.openLanguageComponent : false}
                        onClick={this.openLanguageComponentHandler}
                        onBlur={this.onBlurLanguageComponentHandler}
                        component={renderSelect}
                    />
                </Grid>
            );
        } catch (err) {

        }
    };
    //#endregion

    //#region Service Branch
    openServiceBranchComponentHandler = () => {
        try {
            this.setState((prevState) => ({ openServiceBranchComponent: !prevState.openServiceBranchComponent }));
        } catch (err) { }
    };

    serviceBranchComponentOnChangeHandler = (newItem) => {
        try {
            this.setState(
                { serviceBranchOptionSelected: newItem },
                () => this.setState({ openServiceBranchComponent: false })
            );

            this.props.dispatch(change('EditResidentForm', 'ServiceBranchComponent', newItem))


        } catch (err) { }
    };

    onBlurServiceBranchComponentHandler = () => {
        try {
            this.setState({ openServiceBranchComponent: false })
        } catch (err) { }
    };

    ServiceBranchComponent = () => {
        try {
            let serviceBranchArray = ["Air Force", "Army", "Coast Guard", "Marine Corps", 'Navy'];
            serviceBranchArray.sort().push('Prefer not to answer');
            const serviceBranchoptionsArray = serviceBranchArray.map((branch) => ({ name: branch }));

            return (
                <Grid item container xs={12} className="contentModal" >
                    <Field
                        idToSet="resident_service_branch"
                        name="ServiceBranchComponent"
                        label="Branch of Service"
                        maxLength={20}
                        selected={this.state.serviceBranchOptionSelected ? this.state.serviceBranchOptionSelected : { name: '' }}
                        onChangeHandler={(evet, newItem) => this.serviceBranchComponentOnChangeHandler(newItem)}
                        optionsItemsIconsData={serviceBranchoptionsArray ? serviceBranchoptionsArray : []}
                        open={this.state.openServiceBranchComponent ? this.state.openServiceBranchComponent : false}
                        onClick={this.openServiceBranchComponentHandler}
                        onBlur={this.onBlurServiceBranchComponentHandler}
                        component={renderSelect}
                    />
                </Grid>
            )
        } catch (err) { }
    };
    //#endregion 

    //#region Engage preference
    openEngagePreferenceComponentHandler = () => {
        try {
            this.setState((prevState) => ({ openEngagePreferenceComponent: !prevState.openEngagePreferenceComponent }));
        } catch (err) { }
    };

    EngagePreferenceComponentOnChangeHandler = (newItem) => {
        try {
            this.setState(
                { engagePreferenceOptionSelected: newItem },
                () => this.setState({ openEngagePreferenceComponent: false })
            );

            this.props.dispatch(change('EditResidentForm', 'EngagePreferenceComponent', newItem))
        } catch (err) { }
    };

    onBlurEngagePreferennceComponentHandler = () => {
        try {
            this.setState({ openEngagePreferenceComponent: false })
        } catch (err) { }
    };

    EngagePreferenceComponent = () => {
        try {
            const engagePreferenceArray = ["With a group", "Work on your own"];
            const engagePreferenceOprionsArray = engagePreferenceArray.map((preference) => ({ name: preference }));

            return (
                <Grid item container xs={12} className="contentModal" >
                    <Field
                        idToSet='addEditResident_EngagePreference'
                        name="EngagePreferenceComponent"
                        label="Engage Preference"
                        maxLength={20}
                        selected={this.state.engagePreferenceOptionSelected ? this.state.engagePreferenceOptionSelected : { name: '' }}
                        onChangeHandler={(evet, newItem) => this.EngagePreferenceComponentOnChangeHandler(newItem)}
                        optionsItemsIconsData={engagePreferenceOprionsArray ? engagePreferenceOprionsArray : []}
                        open={this.state.openEngagePreferenceComponent ? this.state.openEngagePreferenceComponent : false}
                        onClick={this.openEngagePreferenceComponentHandler}
                        onBlur={this.onBlurEngagePreferennceComponentHandler}
                        component={renderSelect}
                    />
                </Grid>
            )
        } catch (err) { }
    };
    //#endregion

    //#region Children
    ChildrenComponent = () => {
        try {
            return (
                <Grid item container xs={12} className="contentModal" justify='flex-start'>
                    <Grid item container xs={10} md={7} lg={6}>
                        <Field
                            idToSet="addEditResident_Children"
                            labelInLeft={false}
                            name="children"
                            label="Children "
                            checked={this.state.children}
                            onClick={() => this.setState((prevState) => ({ children: !prevState.children }))}
                            component={renderSwitchWithLabel}
                            stylesLabel={{ fontWeight: 'bold', textAlign: 'left', paddingLeft: '10px', fontSize: '14px', color: '#F0EFEF', }}
                        />
                    </Grid>
                </Grid>
            )
        } catch (err) { }
    }
    //#endregion

    //#region childrenQty
    ChildrenQtyComponent = () => {
        try {
            return (
                <Grid item xs={12} className="contentModal" style={{ padding: '5px 0' }}>
                    <TextField
                        id="addEditResident_ChildrenQty"
                        label="Number of Children"
                        style={{ width: '100%', paddingRight: '15px', color: '#606060' }}
                        value={this.state.childrenQty ? this.state.childrenQty : ''}
                        onChange={(newItem) => this.setState({ childrenQty: this.GetNumberValidated(newItem.target.value, 'children') })}
                        disabled={this.state.children ? false : true}
                        stylesLabel={{ fontWeight: 'bold', textAlign: 'left', paddingLeft: '10px', fontSize: '14px', color: '#F0EFEF', }}
                    />
                </Grid>
            )
        } catch (err) { }
    };
    //#endregion

    //#region GrandChildren
    GrandChildrenComponent = () => {
        try {
            return (
                <Grid item container xs={12} className="contentModal" justify='flex-start'>
                    <Grid item container xs={10} md={7} lg={6}>
                        <Field
                            idToSet="addEditResident_Grandchildren"
                            labelInLeft={false}
                            name="grandchildren"
                            label="Grandchildren "
                            checked={this.state.grandchildren}
                            onClick={() => this.setState((prevState) => ({ grandchildren: !prevState.grandchildren }))}
                            component={renderSwitchWithLabel}
                            stylesLabel={{ fontWeight: 'bold', textAlign: 'left', paddingLeft: '10px', fontSize: '14px', color: '#F0EFEF', }}
                        />
                    </Grid>
                </Grid>
            )
        } catch (err) { }
    }
    //#endregion

    //#region GrandChildrenQty
    GrandChildrenQtyComponent = () => {
        try {
            return (
                <Grid item xs={12} className="contentModal" style={{ padding: '5px 0' }}>
                    <TextField
                        id="addEditResident_GrandchildrenQty"
                        label="Number of Grandchildren"
                        style={{ width: '100%', paddingRight: '15px', color: '#606060' }}
                        value={this.state.grandChildrenQty ? this.state.grandChildrenQty : ''}
                        disabled={this.state.grandchildren ? false : true}
                        onChange={(newItem) => this.setState({ grandChildrenQty: this.GetNumberValidated(newItem.target.value, 'grandchildren') })}
                    />
                </Grid>
            )
        } catch (err) { }
    };
    //#endregion

    //#region EditResident Profile Image Component
    ProfileImageComponent = () => {
        try {
            return (
                <Grid item container xs={12}>
                    <Grid container direction='colum'>
                        <Grid item xs={12} className="ResidentColumTitle">Profile Image</Grid>
                        <Grid item xs={12}>
                            <Grid item xs={12}>
                                <Grid container direction='column' className="residentGridContent residentImageContent">
                                    <Grid item xs={12} alignItems='center' justify='center'>
                                        <RenderImageLoader
                                            idToSet='addEditResident_ProfileImage'
                                            styleCardContentStyles={{ borderRadius: '50%', width: '182px', height: '182px', margin: 'auto', marginTop: '10px' }}
                                            divTextStyles={{ bottom: '0px' }}
                                            styleInputFileStyles={{ borderRadius: '50%' }}
                                            imageStyles={{ borderRadius: '50%', backgroundColor: '#5c5a5a', width: '100%', height: '100%' }}
                                            innerCard={{ borderRadius: '50%', overflow: 'hidden' }}
                                            text='Edit'
                                            residentName={this.GetResidentInitial(this.state.selectedResidentFirstName, this.state.selectedResidentLastName)}
                                            imageUrl={this.state.selectedResidentPictureUrl === 'https://engage360.s3.amazonaws.com/Residents/profile.png' ? " " : this.state.selectedResidentPictureUrl}
                                            disabled={false}
                                            imageName=''
                                            onChange={(e) => this.readImage(e, 'selectedResidentImage')}
                                        />
                                        <Grid id='addEditResident_deliteImage_Btn' className={this.state.selectedResidentPictureUrl === 'https://engage360.s3.amazonaws.com/Residents/profile.png' ? 'deleteImageBtnDisabled' : 'deleteImageBtn'} onClick={this.deleteResidentImage}>
                                            Delete Image
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid container direction='colum'>
                        <Grid item xs={12} className="ResidentColumTitle">Voice</Grid>
                        <Grid item xs={12}>
                            <Grid container className='setUpGridColum' direction='colum'>
                                <Grid item container xs={12} style={{ padding: '10px' }}>
                                    <Grid item container id='breakfastcontainer'>
                                        <Grid item xs={2} sm={2} md={2} >
                                            <Field
                                                idToSet='setup_general_voiceId_switch'
                                                name="isVoiceAvailable"
                                                checked={this.state.isVoiceAvailable === undefined ? false : this.state.isVoiceAvailable}
                                                onClick={this.handleVoiceClick}
                                                component={renderSwitchV2}
                                            />
                                        </Grid>
                                        <Grid item xs={10} sm={10} md={10} className="VoiceTitle">
                                            
                                        </Grid>
                                        <Grid item xs={2} sm={2} md={2} >
                                        </Grid>
                                        <Grid item xs={10} sm={10} md={10}>
                                            <Grid item xs={12} sm={12} md={12} className="VoiceSubTitle">
                                                <h4>Turning Voice on will enable Voice for the resident and default their FAV1 remote button to Voice.</h4>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            )
        } catch (err) {
            return <Grid item container xs={12}></Grid>
        }
    };
    //#endregion

    //#region  CommonNameComponent

    ChangeCommonNameValue = (newValue) => {
        try {
            if (newValue.length > 35) return undefined;

            this.setState({ onErrorCommonName: false, commonName: this.Capitalize(this.CheckForValidCaracters(newValue)) });
            this.props.handlerOnErrorFirstName(this.state.onErrorCommonName)
        } catch (err) { }
    }

    CommonNameComponent = () => {
        try {

            return (
                <Grid item container xs={12}>
                    <Grid item container xs={12}>
                        <TextField
                            id='residentPage_CommonName'
                            error={this.state.onErrorCommonName}
                            onBlur={() => this.isOnError('CommonName')}
                            helperText={this.state.onErrorCommonName ? this.state.errorGenericText : undefined}
                            className="newTextFielStyles contentModal"
                            label={'Common Name'}
                            placeholder={'Common Name'}
                            value={this.state.commonName}
                            onChange={(e) => {
                                this.ChangeCommonNameValue(e.target.value);
                            }}
                        />
                    </Grid>
                    <Grid item container justify="flex-end" alignContent="center">
                        {
                            (this.state.commonName && this.state.commonName.length > 0) ?
                                <Grid item style={{ color: '#949494', fontSize: '16px' }}>{`${(this.state.commonName) ? this.state.commonName.length : 0}/35`}</Grid>
                                :
                                undefined
                        }
                    </Grid>
                    <Grid item container xs={12} justify='flex-start'>
                        <Grid item style={{ fontSize: '11px', color: '#9d9c9d', textAlign: 'justify' }}>
                            {'Common Name is only used for the custom greeting on the EHub. Entering a Common Name here will change the custom greeting from, for example, "Good morning, Barbara" to "Good morning, Smiths." Enter Common Name as plural.'}
                        </Grid>
                    </Grid>
                </Grid>
            )
        } catch (err) {
            return (<Grid item container></Grid>)
        }
    }
    //#endregion

    //#region EditResident  Resident Data Component
    ResidentDataComponent = () => {
        try {
            return (
                <Grid item container xs={12}>
                    <Grid container direction='colum'>
                        <Grid item xs={12} className="ResidentColumTitle">Resident</Grid>
                        <Grid item xs={12}>
                            <Grid container direction='column' className="residentGridContent">
                                <Grid item xs={12} className="contentModal">
                                    <TextField
                                        id='residentPage_EditResident_FirstName'
                                        autoFocus={true}
                                        error={this.state.onErrorSelectedResidentFirstName}
                                        onBlur={() => this.isOnError('selectedresidentfirstname')}
                                        helperText={this.state.onErrorSelectedResidentFirstName ? this.state.errorGenericText : undefined}
                                        className="newTextFielStyles contentModal"
                                        label={'First Name'}
                                        placeholder={'First Name'}
                                        value={this.state.selectedResidentFirstName}
                                        onChange={(e) => {
                                            this.setState({ onErrorSelectedResidentFirstName: false, selectedResidentFirstName: this.Capitalize(this.CheckForValidCaracters(e.target.value)) });
                                            this.props.handlerOnErrorFirstName(this.state.onErrorSelectedResidentFirstName)
                                        }}
                                    />
                                    <TextField
                                        id='residentPage_EditResident_LastName'
                                        error={this.state.onErrorSelectedResidentLastName}
                                        onBlur={() => this.isOnError('selectedresidentlastname')}
                                        helperText={this.state.onErrorSelectedResidentLastName ? this.state.errorGenericText : undefined}
                                        className="newTextFielStyles contentModal"
                                        label={'Last Name'}
                                        placeholder={'Last Name'}
                                        value={this.state.selectedResidentLastName}
                                        onChange={(e) => {
                                            this.setState({ onErrorSelectedResidentLastName: false, selectedResidentLastName: this.Capitalize(this.CheckForValidCaracters(e.target.value)) });
                                            this.props.handlerOnErrorLastName(this.state.onErrorSelectedResidentLastName)
                                        }}
                                    />

                                    <TextField
                                        id='residentPage_EditResident_Location'
                                        className="newTextFielStyles contentModal"
                                        label={'Location'}
                                        placeholder={'Location'}
                                        value={this.state.selectedResidentLocation}
                                        onChange={(e) => { this.setState({ selectedResidentLocation: this.CheckForValidCaracters(e.target.value, 'numbers') }) }}
                                    />

                                    <Grid xs={12} className="contentModal">
                                        <Field
                                            idToSet='addEditResident_BirthDate'
                                            name='BirthDateField'
                                            labelDate="Birthdate"
                                            selectedDate={this.state.selectedResidentBirthday} //most be an date object is use in both date and time
                                            onDateChange={(date) => {
                                                let dateChanged = date === null ? new Date() : date;
                                                if (dateChanged > new Date()) {
                                                    const message = 'The birth date must be in the past'
                                                    sweetAlert('error', message, 'alert_AddEditResident_FutureBirthdate_Error');
                                                    this.setState({ selectedResidentBirthday: new Date() });
                                                } else {

                                                    this.setState({ selectedResidentBirthday: date });
                                                }
                                            }}
                                            fieldFocus={() => this.changeDateFormat('MM/dd/yyyy')}
                                            fieldBlur={() => this.changeDateFormat('MMMM dd, yyyy')}
                                            dateFormat={this.state.dateFormat}
                                            isFieldFocused={this.state.dateFormat === 'MM/dd/yyyy'}
                                            disabledDates={{ maxDate: new Date() }}
                                            maxLength={20}
                                            InputLabelProps={{ shrink: true, }}
                                            component={renderSingleDateFormattedPicker}
                                            className="newTextFielStyles contentModal"
                                        />
                                    </Grid>
                                    <Grid item container xs={12}>
                                        <this.CommonNameComponent />
                                    </Grid>
                                    <Grid item container xs={12}>
                                        <this.AgeComponent />
                                    </Grid>
                                    <Grid item container xs={12}>
                                        <this.LanguageComponent />
                                    </Grid>
                                    <Grid item container xs={12} >
                                        <this.MoveInDateComponent />
                                    </Grid>
                                    <Grid item container xs={12}>
                                        <this.EngagePreferenceComponent />
                                    </Grid>
                                    <Grid item container xs={12}>
                                        <this.EhubInitiationDateComponent />
                                    </Grid>
                                    <Grid item container xs={12}>
                                        <this.NormalWakeTimeComponent />
                                    </Grid>
                                    <Grid item container xs={12}>
                                        <this.NormalBedTimeComponent />
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            )
        } catch (err) {
            return <Grid item container xs={12}></Grid>
        }
    };
    //#endregion

    //#region EditResident Identifiers Component
    IdentifiersComponent = () => {
        try {

            return (
                <Grid item container xs={12}>
                    <Grid container direction='colum'>
                        <Grid item xs={12} className="ResidentColumTitle">Identifiers</Grid>
                        <Grid item xs={12}>
                            <Grid container direction='column' className="residentGridContent">
                                <Grid item xs={12}>
                                    <Grid item xs={12}>
                                        <Field
                                            idToSet='addEditResident_switchTagField'
                                            name="residentFormIdentifiers"
                                            label="Tags"
                                            inputClass='contentModal'
                                            value={this.state.selectedResidentTagText}
                                            maxLength={20}
                                            chipsOptions={this.state.selectedResidentIdentifiers}
                                            handlerOnChipDelete={(chipText) => this.handlerOnResidentFormChipDelete(chipText)}
                                            handlerOnClickAddButton={() => { this.handleOnClickResidentFormAddButton() }}
                                            onChange={(e) => { this.setState({ selectedResidentTagText: e.target.value }) }}
                                            onKeyDown={e => { if (e && e.keyCode && e.keyCode === 13) { this.handleOnClickResidentFormAddButton(); } }}
                                            component={renderTextFieldWithChips}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            )
        } catch (err) {
            return <Grid item container xs={12}></Grid>
        }
    };
    //#endregion

    //#region  Edit Resident Family Information Component
    FamilyInformationComponent = () => {
        try {
            return (
                <Grid item container xs={12}>
                    <Grid item xs={12} className="ResidentColumTitle">Family Information</Grid>
                    <Grid item container xs={12} className="residentGridContent">
                        <Grid container item xs={12} justify='flex-end'>


                            <Grid item container xs={12}>
                                <this.ChildrenComponent />
                            </Grid>
                            {
                                this.state.children ?
                                    <Grid item container xs={12}>
                                        <this.ChildrenQtyComponent />
                                    </Grid>
                                    :
                                    undefined
                            }

                            <Grid item container xs={12}>
                                <this.GrandChildrenComponent />
                            </Grid>
                            {
                                this.state.grandchildren ?
                                    <Grid item container xs={12}>
                                        <this.GrandChildrenQtyComponent />
                                    </Grid>
                                    :
                                    undefined
                            }

                            <Grid item container xs={12}>
                                <this.SexComponent />
                            </Grid>
                            <Grid item container xs={12}>
                                <this.MaritalStatusComponent />
                            </Grid>
                            {
                                this.state.maritalStatusOptionsSelected &&
                                    this.state.maritalStatusOptionsSelected.name &&
                                    this.state.maritalStatusOptionsSelected.name.toLowerCase() === 'married' ?

                                    <Grid item container xs={12}>
                                        <this.WeddingAnniversaryComponent />
                                    </Grid>
                                    :
                                    undefined
                            }

                        </Grid>
                    </Grid>
                </Grid>
            )
        } catch (err) {
            return <Grid item container xs={12}></Grid>
        }
    }
    //#endregion

    //#region EditResident ServiceInformationComponent
    ServiceInformationComponent = () => {
        try {
            return (
                <Grid item container xs={12}>
                    <Grid item xs={12} className="ResidentColumTitle">Service Information</Grid>
                    <Grid item container xs={12} className="residentGridContent">
                        <Grid item container xs={12}>
                            <this.VeteranComponent />
                        </Grid>
                        {
                            this.state.veteranComponentOptionSelected && this.state.veteranComponentOptionSelected.name === 'Yes' ?
                                <this.ServiceBranchComponent />
                                :
                                undefined
                        }
                    </Grid>
                </Grid>
            )
        } catch (err) {
            return <Grid item container xs={12}></Grid>
        }
    }
    //#endregion

    //#region EditResident SpiritualityInformationComponent
    SpiritualityInformationComponent = () => {
        return (
            <Grid item container xs={12}>
                <Grid item xs={12} className="ResidentColumTitle">Spiritual Information</Grid>
                <Grid item container xs={12} className="residentGridContent">
                    <Grid item container xs={12}>
                        <this.SpiritualityComponent />
                    </Grid>
                </Grid>
            </Grid>
        )
    }
    //#endregion

    //#region EditResident FamilyMenbersInformationComponent
    FamilyMenbersInformationComponent = () => {
        try {

            const displayHeaders = this.state.isMobile ? 'none' : 'flex';

            return (
                <Grid item container xs={12}>
                    <Grid item container xs={12} className="ResidentColumTitle">Family Members</Grid>
                    <Grid item container xs={12}>
                        <Grid item container direction='column' className="residentGridContent">
                            <Grid item container >
                                {/* //RM */}
                                <Grid item container style={{ flexGrow: 1, display: displayHeaders }} >
                                    <Grid item xs={12} sm={12} md={9}>Name</Grid>
                                    <Grid item xs={12} sm={12} md={3}>Remove</Grid>
                                </Grid>
                                <Grid item container>
                                    {
                                        this.state.selectedResidentFamilyMembers && this.state.selectedResidentFamilyMembers.map((item, index) => {
                                            return (
                                                <Grid container key={index} alignItems='center' justify='center' className="residentFamilyDevices">
                                                    <Grid item xs={12} sm={12} md={9} style={{ overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>{item.name}</Grid>
                                                    <Grid item container xs={12} sm={12} md={3} className='EngageButonClass' style={{ alignContent: 'center', display: 'flex', justifyContent: 'center' }}>
                                                        <Button
                                                            variant="contained"
                                                            value={item._id}
                                                            style={{ backgroundColor: '#db5b70' }}
                                                            onClick={(e) => {
                                                                this.handleDelete(e, item);
                                                            }}
                                                        >
                                                            <BlockIcon style={{ color: 'white' }} />
                                                        </Button>
                                                    </Grid>
                                                </Grid>
                                            )
                                        })
                                    }

                                    <div style={{ marginLeft: 'auto', marginRight: '0', width: '100%' }} >
                                        <Grid item xs={12} >
                                            {
                                                this.state.selectedResidentFamilyMembers && this.state.selectedResidentFamilyMembers.length ?
                                                    undefined
                                                    :
                                                    <Grid container style={{ padding: '5px', borderRadius: '4px', marginTop: '6px' }}>
                                                        <Grid item xs={12} sm={12} md={12} style={{ textAlign: 'center' }}>No family members!</Grid>
                                                    </Grid>
                                            }
                                        </Grid>
                                    </div>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            )
        } catch (err) {
            return <Grid item container xs={12}></Grid>;
        }
    }
    //#endregion

    //#region EditResident DeviceInformationComponent
    DeviceInformationComponent = () => {
        try {
            const displayHeaders = this.state.isMobile ? 'none' : 'flex';

            return (
                <Grid item container xs={12}>
                    <Grid item container xs={12} className="ResidentColumTitle">Devices</Grid>
                    <Grid item container xs={12}>
                        <Grid item container direction='column' className="residentGridContent">
                            <Grid item container >
                                {/* //RM */}
                                <Grid item container style={{ flexGrow: 1, display: displayHeaders }} >
                                    <Grid item xs={6}>Serial</Grid>
                                    <Grid item xs={6}>DOCSIS MAC</Grid>
                                </Grid>
                                <Grid item container>
                                    {
                                        this.state.selectedResidentDevices && this.state.selectedResidentDevices.map((item, index) => {
                                            return (
                                                <Grid item container key={index} className="residentFamilyDevices" >
                                                    <Grid item xs={12} sm={12} md={6} style={{ textAlign: 'center' }}>{item.serial}</Grid>
                                                    <Grid item xs={12} sm={12} md={6} style={{ textAlign: 'center' }}>{item.docsis}</Grid>
                                                </Grid>
                                            )
                                        })
                                    }

                                    <div style={{ marginLeft: 'auto', marginRight: '0', width: '100%' }} >
                                        <Grid item xs={12} >
                                            {
                                                this.state.selectedResidentDevices && this.state.selectedResidentDevices.length ?
                                                    undefined
                                                    :
                                                    <Grid item container style={{ padding: '5px', borderRadius: '4px', marginTop: '6px' }}>
                                                        <Grid item xs={12} sm={12} md={12} style={{ textAlign: 'center' }}>No devices!</Grid>
                                                    </Grid>
                                            }
                                        </Grid>
                                    </div>
                                </Grid>
                            </Grid>

                        </Grid>
                    </Grid>
                </Grid>
            )
        } catch (err) {
            return <Grid item container xs={12}></Grid>
        }
    }
    //#endregion

    onClickContinueResidentModal = () => {

        if (!(this.state.onErrorModalFirstName || this.state.onErrorModalLastName || this.state.onErrorModalLocation))
            this.setState(prevState => ({ activeStep: prevState.activeStep + 1 }))
    }

    onClickStepResidentModal = (step) => {

        if (step <= this.state.activeStep) {
            this.setState({ activeStep: step })
        }
    }

    //#region Add New Resident Modal
    AddNewResidentModelComponent = () => {
        try {
            const imageWidth = (this.state.rootFontSize.name === 'xs' || this.state.rootFontSize.name === 'sm') ? 12 : (this.state.rootFontSize.name === 'md') ? 15 : 16;
            const imageHeight = (this.state.rootFontSize.name === 'xs' || this.state.rootFontSize.name === 'sm') ? 12 : (this.state.rootFontSize.name === 'md') ? 15 : 16;

            return (
                <Modal
                    open={this.state.openModal}
                    onClose={() => this.cleanModal()}
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                    onRendered={() => { this.setState({ onErrorModalFirstName: true, onErrorModalLastName: true, onErrorModalLocation: true }) }}
                >
                    <Paper elevation={0} className="paperModal" color='secondary'>
                        <Grid container xs={12}>
                            <Grid item container xs={12} className="titleResidentModal">
                                <Grid style={{ textAlign: 'left' }}>
                                    New Resident
                                </Grid>
                            </Grid>
                        </Grid>
                        {
                            <Grid item container xs={12} justify='center' alignItems='center' >
                                <Stepper nonLinear activeStep={this.state.activeStep} className="stepperModal">
                                    <Step key={0} className={this.state.activeStep > 0 ? "StepStyles" : ""}><StepLabel onClick={() => { this.setState({ activeStep: 0 }) }} className={this.state.activeStep > 0 ? "StepLabelStyles" : ""}></StepLabel></Step>
                                    <Step key={1} className={this.state.activeStep > 1 ? "StepStyles" : ""}><StepLabel onClick={() => { this.onClickStepResidentModal(1) }} className={this.state.activeStep > 1 ? "StepLabelStyles" : ""}></StepLabel></Step>
                                    <Step key={2} className={this.state.activeStep > 2 ? "StepStyles" : ""}><StepLabel onClick={() => { this.onClickStepResidentModal(2) }} className={this.state.activeStep > 2 ? "StepLabelStyles" : ""}></StepLabel></Step>
                                    <Step key={3}><StepLabel></StepLabel></Step>
                                </Stepper>
                            </Grid>
                        }
                        <Grid container xs={12} justify='center' alignItems='center'>
                            <SwipeableViews
                                axis={'x'}
                                index={this.state.activeStep}
                                onChangeIndex={this.handleChangeIndex}
                                style={{ width: '90%', height: '100%', padding: '0' }}
                            >
                                {/* TabPanel Names */}
                                <TabPanel value={this.state.activeStep} index={0} dir={'x'} style={{ padding: '0', }} >
                                    <Grid container xs={12} justify='center' alignItems='space-between' style={{ height: '490px' }} >
                                        <Grid item container xs={12} justify='center' alignItems='center' className="subtitleResidentModal">
                                            <Grid item id='AddEditResident_Title_GeneralInformation' >
                                                Enter General Information
                                            </Grid>
                                        </Grid>
                                        <Grid item container xs={7} justify='center' alignItems='center'>
                                            <Grid item xs={12} className="contentModal">
                                                <TextField
                                                    id='residentPage_NewResident_firstName'
                                                    autoFocus={true}
                                                    error={this.state.onErrorModalFirstName}
                                                    onBlur={() => this.isOnError('firstName')}
                                                    helperText={this.state.onErrorModalFirstName ? this.state.errorGenericText : undefined}
                                                    style={{ width: '100%', marginLeft: 'auto', marginRight: 'auto', marginTop: 'auto', marginBottom: '0', paddingRight: '15px' }}
                                                    label={'First Name'}
                                                    placeholder={'First Name'}
                                                    value={this.state.modalFirstName}
                                                    onChange={(e) => { this.setState({ onErrorModalFirstName: false, modalFirstName: this.Capitalize(this.CheckForValidCaracters(e.target.value)) }) }}
                                                />
                                            </Grid>
                                            <Grid item xs={12} className="contentModal">
                                                <TextField
                                                    id='residentPage_NewResident_lastName'
                                                    error={this.state.onErrorModalLastName}
                                                    onBlur={() => this.isOnError('lastname')}
                                                    helperText={this.state.onErrorModalLastName ? this.state.errorGenericText : undefined}
                                                    style={{ width: '100%', marginLeft: 'auto', marginRight: 'auto', marginTop: 'auto', marginBottom: '0', paddingRight: '15px' }}
                                                    label={'Last Name'}
                                                    placeholder={'Last Name'}
                                                    value={this.state.modalLastName}
                                                    onChange={(e) => { this.setState({ onErrorModalLastName: false, modalLastName: this.Capitalize(this.CheckForValidCaracters(e.target.value)) }) }}
                                                />
                                            </Grid>
                                            <Grid item xs={12} className="contentModal">
                                                <TextField
                                                    id='residentPage_NewResident_location'
                                                    error={this.state.onErrorModalLocation}
                                                    onBlur={() => this.isOnError('location')}
                                                    helperText={this.state.onErrorModalLocation ? this.state.errorGenericText : undefined}
                                                    style={{ width: '100%', marginLeft: 'auto', marginRight: 'auto', marginTop: 'auto', marginBottom: '0', paddingRight: '15px' }}
                                                    label={'Location'}
                                                    placeholder={'Location'}
                                                    value={this.state.modalLocation}
                                                    onChange={(e) => { this.setState({ modalLocation: this.CheckForValidCaracters(e.target.value) }) }}
                                                />
                                            </Grid>
                                            <Grid item xs={12} className="contentModal">
                                                <Field
                                                    idToSet='residentPage_NewResident_birthDate'
                                                    labelDate="Birthdate"
                                                    selectedDate={this.state.modalBirthDay} //most be an date object is use in both date and time
                                                    fieldFocus={() => this.changeDateFormat('MM/dd/yyyy')}
                                                    fieldBlur={() => this.changeDateFormat('MMMM dd, yyyy')}
                                                    dateFormat={this.state.dateFormat}
                                                    isFieldFocused={this.state.dateFormat === 'MM/dd/yyyy'}
                                                    disabledDates={{ maxDate: new Date() }}
                                                    onDateChange={(date) => {
                                                        let dateChanged = date === null ? new Date() : date;
                                                        if (dateChanged > new Date()) {
                                                            const message = 'The birth date must be in the past'
                                                            sweetAlert('error', message, 'alert_AddEditResident_FutureBirthdate_Error');
                                                            this.setState({ modalBirthDay: new Date() });
                                                        } else {

                                                            this.setState({ modalBirthDay: date });
                                                        }
                                                    }
                                                    }
                                                    maxLength={20}
                                                    component={renderSingleDateFormattedPicker}
                                                />
                                            </Grid>
                                            <Grid item container xs={12}>
                                                <this.CommonNameComponent />
                                            </Grid>
                                            <Grid item container xs={12}>
                                                <this.AgeComponent />
                                            </Grid>
                                        </Grid>
                                        <Grid item container xs={12} justify='center' alignItems='flex-end' className="buttonsModal" >
                                            <Grid item
                                                id='residentPage_NewResident_CancelBtn'
                                                className="appbtn-engage"
                                                onClick={() => this.cleanModal()}
                                                style={{ ...this.Modal.visibleButton, backgroundColor: '#959494' }}
                                            >
                                                Cancel
                                            </Grid>
                                            <Grid item
                                                id='residentPage_NewResident_ContinueBtn'
                                                className={(!(this.state.onErrorModalFirstName || this.state.onErrorModalLastName || this.state.onErrorModalLocation)) ? "appbtnModal-engage register_modal_register_btn" : "appbtnModal-engage register_modal_register_btn_disabled"}
                                                onClick={this.onClickContinueResidentModal}
                                            >
                                                Continue
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </TabPanel>

                                {/* TabPanel moving date */}
                                <TabPanel value={this.state.activeStep} index={1} dir={'x'} style={{ padding: '0', }} >
                                    <Grid container xs={12} justify='center' alignItems='space-between' style={{ height: '490px' }} >
                                        <Grid item container xs={12} justify='center' alignItems='center' className="subtitleResidentModal">
                                            <Grid item id='AddEditResident_Title_AdditionalInformation'>
                                                Additional Information
                                            </Grid>
                                        </Grid>

                                        <Grid item container xs={7} justify='center' alignItems='center' >
                                            <Grid item container xs={12}>
                                                <this.ChildrenComponent />
                                            </Grid>

                                            {
                                                this.state.children ?
                                                    <Grid item container xs={12}>
                                                        <this.ChildrenQtyComponent />
                                                    </Grid>
                                                    :
                                                    undefined
                                            }
                                            <Grid item container xs={12}>
                                                <this.GrandChildrenComponent />
                                            </Grid>
                                            {
                                                this.state.grandchildren ?
                                                    <Grid item container xs={12}>
                                                        <this.GrandChildrenQtyComponent />
                                                    </Grid>
                                                    :
                                                    undefined
                                            }

                                            <Grid item container xs={12}>
                                                <this.SexComponent />
                                            </Grid>

                                            <Grid item container xs={12}>
                                                <this.MaritalStatusComponent />
                                            </Grid>
                                            {
                                                this.state.maritalStatusOptionsSelected &&
                                                    this.state.maritalStatusOptionsSelected.name &&
                                                    this.state.maritalStatusOptionsSelected.name.toLowerCase() === 'married' ?

                                                    <Grid item container xs={12}>
                                                        <this.WeddingAnniversaryComponent />
                                                    </Grid>
                                                    :
                                                    undefined
                                            }
                                            <Grid item container xs={12}>
                                                <this.MoveInDateComponent />
                                            </Grid>
                                            <Grid item container xs={12}>
                                                <this.SpiritualityComponent />
                                            </Grid>
                                            <Grid item container xs={12}>
                                                <this.VeteranComponent />
                                            </Grid>
                                            {
                                                this.state.veteranComponentOptionSelected && this.state.veteranComponentOptionSelected.name === 'Yes' ?
                                                    <this.ServiceBranchComponent />
                                                    :
                                                    undefined
                                            }
                                            <Grid item container xs={12}>
                                                <this.LanguageComponent />
                                            </Grid>
                                            <Grid item container xs={12}>
                                                <this.EngagePreferenceComponent />
                                            </Grid>
                                            <Grid item container xs={12} >
                                                <this.EhubInitiationDateComponent />
                                            </Grid>
                                            <Grid item container xs={12}>
                                                <this.NormalWakeTimeComponent />
                                            </Grid>
                                            <Grid item container xs={12}>
                                                <this.NormalBedTimeComponent />
                                            </Grid>
                                        </Grid>
                                        <Grid item container xs={12} justify='center' alignItems='flex-end' className="buttonsModal" >
                                            <Grid item
                                                id='addEditResident_Btn_Back'
                                                className='appbtn-engage'
                                                onClick={() => this.setState(prevState => ({ activeStep: prevState.activeStep - 1 }))}
                                                style={{ ...this.Modal.visibleButton, backgroundColor: '#959494' }}
                                            >
                                                Back
                                            </Grid>
                                            <Grid item
                                                id='addEditResident_Btn_Skip'
                                                className="appOutlinebtn-engage"
                                                style={this.Modal.visibleOutlinedButton}
                                                onClick={() => this.setState(prevState => ({ activeStep: prevState.activeStep + 1 }))}
                                            >
                                                Skip
                                            </Grid>
                                            <Grid item
                                                id='addEditResident_Btn_Continue'
                                                className="appbtn-engage"
                                                style={{ ...this.Modal.visibleButton, backgroundColor: '#009edd' }}
                                                onClick={() => this.setState(prevState => ({ activeStep: prevState.activeStep + 1 }))}
                                            >
                                                Continue
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </TabPanel>

                                {/* TabPanel Profile Picture */}
                                <TabPanel value={this.state.activeStep} index={2} dir={'x'} style={{ padding: '0', }}>
                                    <Grid container justify='center' alignItems='space-between' style={{ height: '490px' }}>
                                        <Grid item container xs={12} justify='center' alignItems='center' className="subtitleResidentModal">
                                            <Grid item id='AddEditResident_Title_AddProfileImage'>
                                                Add Profile Image
                                            </Grid>
                                        </Grid>
                                        <Grid item container xs={7} justify='center' alignItems='center'>
                                            <Grid item>
                                                <RenderImageLoader
                                                    idToSet='addEditResdient_profilePicture_RenderImage'
                                                    styleCardContentStyles={{ borderRadius: '50%', width: imageWidth + 'rem', height: imageHeight + 'rem', padding: '1rem' }}
                                                    divTextStyles={{ bottom: '0px' }}
                                                    styleInputFileStyles={{ borderRadius: '50%', }}
                                                    imageStyles={{ borderRadius: '50%', backgroundColor: '#959494', width: '100%', height: '100%' }}
                                                    innerCard={{ borderRadius: '50%', overflow: 'hidden' }}
                                                    text='Edit'
                                                    residentName={this.GetResidentInitial(this.state.modalFirstName, this.state.modalLastName)}
                                                    imageUrl={this.state.selectedResidentImage === 'https://engage360.s3.amazonaws.com/Residents/profile.png' ? " " : this.state.selectedResidentImage}
                                                    disabled={false}
                                                    imageName=''
                                                    onChange={(e) => this.readImage(e, 'residentImage')}
                                                />
                                            </Grid>
                                        </Grid>
                                        <Grid item container xs={12} justify='center' alignItems='flex-end' className="buttonsModal">
                                            <Grid item
                                                id='addEditResident_Btn_Back'
                                                className='appbtn-engage'
                                                onClick={() => this.setState(prevState => ({ activeStep: prevState.activeStep - 1 }))}
                                                style={{ ...this.Modal.visibleButton, backgroundColor: '#959494' }}
                                            >
                                                Back
                                            </Grid>
                                            <Grid item
                                                id='addEditResident_Btn_Skip'
                                                className="appOutlinebtn-engage"
                                                style={this.Modal.visibleOutlinedButton}
                                                onClick={() => this.setState(prevState => ({ activeStep: prevState.activeStep + 1 }))}
                                            >
                                                Skip
                                            </Grid>
                                            <Grid item
                                                id='addEditResident_Btn_Continue'
                                                className="appbtn-engage"
                                                style={{ ...this.Modal.visibleButton, backgroundColor: '#009edd' }}
                                                onClick={() => this.setState(prevState => ({ activeStep: prevState.activeStep + 1 }))}
                                            >
                                                Continue
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </TabPanel>

                                {/* TabPanel Tags */}
                                <TabPanel value={this.state.activeStep} index={3} dir={'x'} style={{}}>
                                    <Grid container justify='center' alignItems='space-between' style={{ height: '490px' }} >
                                        <Grid item container xs={12} justify='center' alignItems='center' className="subtitleResidentModal">
                                            <Grid item id='AddEditResident_Title_AddIdentifiers' >
                                                Add Identifiers
                                            </Grid>
                                        </Grid>
                                        <Grid item container xs={6} justify='center' alignItems='center' className="contentModalNoOpacity">
                                            <Field
                                                idToSet='addEditResident_switchTagField'
                                                name="modalNewResidentTags"
                                                label="Tags"
                                                value={this.state.modalNewTagText}
                                                maxLength={20}
                                                chipsOptions={this.state.modalChipsArray}
                                                handlerOnChipDelete={(chipText) => this.handlerOnModalChipDelete(chipText)}
                                                handlerOnClickAddButton={() => { this.handleOnClickModalAddButton() }}
                                                onChange={(e) => { this.setState({ modalNewTagText: e.target.value }) }}
                                                onKeyDown={e => { if (e && e.keyCode && e.keyCode === 13) { this.handleOnClickModalAddButton(); } }}
                                                component={renderTextFieldWithChips}
                                            />
                                        </Grid>
                                        <Grid item container xs={12} justify='center' alignItems='flex-end' className="buttonsModal">
                                            <Grid item
                                                id='addEditResident_Btn_Back'
                                                className='appbtn-engage'
                                                onClick={() => this.setState(prevState => ({ activeStep: prevState.activeStep - 1 }))}
                                                style={{ ...this.Modal.visibleButton, backgroundColor: '#959494' }}
                                            >

                                                Back
                                            </Grid>
                                            <Grid item
                                                id='addEditResident_Btn_Save'
                                                className={(this.state.onErrorModalFirstName || this.state.onErrorModalLastName) ? "appbtn-engage colorDisabled" : "appbtn-engage"}
                                                style={(this.state.onErrorModalFirstName || this.state.onErrorModalLastName) ? this.Modal.visibleDisabledButton : { ...this.Modal.visibleButton, backgroundColor: '#009edd' }}
                                                onClick={() => this.handleAddResident()}
                                                disabled={(this.state.onErrorModalFirstName || this.state.onErrorModalLastName)}
                                            >
                                                Save
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </TabPanel>

                            </SwipeableViews>
                        </Grid>
                    </Paper>
                </Modal>
            )
        } catch (err) {
            return <Grid item container xs={12}></Grid>
        }
    }
    //#endregion

    handleVoiceClick = () => {
        this.setState((prevState) => ({ isVoiceAvailable: !prevState.isVoiceAvailable }));
    }

    render() {

        /* THIS IS WHERE WE VALIDATE WHEN THE INFORMATION IS SAVED */
        if (this.props.isResidentSuccess.success && (this.props.isResidentSuccess.type === SYNC_RESIDENTS_BY_COMMUNITY_SUCCESS)) {
            this.setState({currentPage: 0}, () => {
                const communityId = localStorage.getItem('communityId');
                this.props.getALLResidentsByCommunityIDPagination(communityId, 1);
            });
        }

        const { handleSubmit } = this.props;

        if (
            (( 
                this.props.residentData &&
                this.props.residentData.length > 0 &&
                !this.state.filterObj
            ) &&
            (
                (!this.state.residents) ||
                (this.state.residents.length !== this.props.residentData.length)
            )) || (this.props.isResidentSuccess.type === SYNC_RESIDENTS_BY_COMMUNITY_SUCCESS)
        ) {
            this.setState({ residents: this.props.residentData })
        }

        const currentResidentData = (this.state.residents && this.state.residents.length > 0) ? this.state.residents : [];

        if ((this.props.data && this.props.data._id) && this.props.communityExists === false) {
            this.props.handleCommunityExist(true);
        } else if (!(this.props.data && this.props.data._id) && this.props.communityExists === true) {
            this.props.handleCommunityExist(false);
        }

        if (this.props.tabSelected !== this.state.tabValue) {
            this.props.handleTabSelectedChange(this.state.tabValue);
        }

        return (
            <div >
                <form >
                    <Grid container>
                        <Grid item xs={12}>
                            <div className="imgalignrigth-engage appbtn-details-engage">
                                <div id="save_btn" className="appbtn-engage skybluebtn-engage" onClick={handleSubmit(this.onSubmitHandler.bind(this))}>
                                    Save
                                </div>
                                <div id="cancel_btn" className="appbtn-engage redbtn-engage" onClick={this.props.closeDialog}>
                                    Cancel
                                </div>
                                <div id='new_resident_btn' className='appbtn-engage purplebtn-engage' onClick={() => { this.cleanModal(); this.setState({ openModal: true, eHubInitiationDate: new Date() }) }}>
                                    New Resident
                                </div>
                                <div id='edit_resident_btn' className='appbtn-engage purplebtn-engage' onClick={() => { this.handlerEditResident(); }}>
                                    Edit Resident
                                </div>
                                <div id='delete_resident_btn' className='appbtn-engage redbtn-engage' onClick={this.handlerDeleteResident}>
                                    Delete Resident
                                </div>
                                <div id='cancel_resident_btn' className='appbtn-engage skybluebtn-angage' onClick={this.handleCancelUpdateResident}>
                                    Cancel
                                </div>
                                <div id='open_Invitation_Modal_btn' className='appbtn-engage skybluebtn-angage' onClick={this.InvitationModal}>
                                    Invite Family Member
                                </div>
                                <div id='sync_Residents_Modal_btn' className='appbtn-engage skybluebtn-angage' onClick={this.SyncResidents}>
                                    Sync Residents
                                </div>
                                <div id='sort_residents_btn' className='appbtn-engage skybluebtn-angage' onClick={this.sortResidents}>
                                    Sort residents
                                </div>
                                <div id='filters_btn' className='appbtn-engage skybluebtn-angage' onClick={this.openFilters}>
                                    Open Filters
                                </div>
                            </div>
                        </Grid>
                    </Grid>
                    {
                        !this.state.isUpdResident ?
                            ///Tabs
                            <React.Fragment>
                                <Grid container >
                                    <Grid container justify='center' className="ResidentTitleContainer">
                                        <Grid item className="ResidentTitle" id='residents_title'>
                                            {`Residents (${(currentResidentData && currentResidentData.length > 0) ? currentResidentData.length : 0})`}
                                        </Grid>
                                    </Grid>
                                    <Grid container >
                                        {
                                            (currentResidentData) ?
                                                currentResidentData.map((item, index) => {
                                                    return (
                                                        <Grid item container xs={6} sm={4} md={3} ref={(currentResidentData.length === index + 1) ? this.lastActivityRef : undefined}>
                                                            <SimpleCard
                                                                idToSet={`resident_card_${item._id}`}
                                                                resident={item}
                                                                handlerClick={this.handleOpenResidentForm}
                                                            />
                                                        </Grid>
                                                    )
                                                })
                                                :
                                                <div>No data found</div>
                                        }
                                    </Grid>
                                </Grid>

                            </React.Fragment>
                            :
                            //Resident Form
                            <React.Fragment >
                                <Grid container >
                                    <Grid item xs={12} sm={6} md={4} className="residentGridForm">
                                        <this.ProfileImageComponent />
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={4} className="residentGridForm">
                                        <this.ResidentDataComponent />
                                    </Grid>

                                    <Grid item xs={12} sm={6} md={4} className="residentGridForm">
                                        <this.IdentifiersComponent />
                                    </Grid>

                                    {/* Additional resident info */}
                                    <Grid item container xs={12} sm={6} md={4} className="residentGridForm" alignContent='flex-start'>
                                        <this.FamilyInformationComponent />
                                    </Grid>
                                    <Grid item container xs={12} sm={6} md={4} className="residentGridForm" alignContent='flex-start'>
                                        <this.ServiceInformationComponent />
                                    </Grid>
                                    <Grid item container xs={12} sm={6} md={4} className="residentGridForm" alignContent='flex-start'>
                                        <this.SpiritualityInformationComponent />
                                    </Grid>


                                    <Grid item xs={12} sm={6} md={6} className="residentGridForm">
                                        <this.FamilyMenbersInformationComponent />
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={6} className="residentGridForm">
                                        <this.DeviceInformationComponent />
                                    </Grid>
                                </Grid>
                            </React.Fragment>
                    }
                </form>

                {
                    this.state.openModal ?
                        <this.AddNewResidentModelComponent />
                        :
                        undefined
                }

                {
                    this.state.openConnectInvitationModal === true ?
                        <ConnectInvitationModal
                            rootFontSize={this.state.rootFontSize}
                            onClose={() => this.setState({ openConnectInvitationModal: false })}
                            residents={this.props.residentData ? this.props.residentData : []}
                            residentSelected={this.state.residentSelected ? this.state.residentSelected : undefined}
                        />
                        :
                        undefined
                }
                {
                    this.state.openFilters === true && this.state.AnchorElId ?
                        <ResidentsFiltersDrawer
                            idAnchorEl={this.state.AnchorElId}
                            onClose={() => this.setState({ openFilters: false, AnchorElId: undefined }, () => this.props.closeFilters())}
                            names={this.props.residentData ? this.props.residentData.map(item => (item.firstName.trim())).sort((a, b) => a.toUpperCase() > b.toUpperCase()) : []}
                            lastNames={this.props.residentData ? this.props.residentData.map(item => (item.lastName.trim())).sort((a, b) => a.toUpperCase() > b.toUpperCase()) : []}
                            zoneNames={this.props.residentData ? this.props.residentData.filter(filter => filter.zoneName ? true : false).map(item =>(item.zoneName.trim())).sort((a, b) => a.toUpperCase() > b.toUpperCase()) : []}
                            onFilterChange={this.onFilterChange}
                            filterObj={this.state.filterObj ? this.state.filterObj : {}}
                            applyFilters={this.applyFilters}
                            resetFilters={this.resetFilters}

                        />
                        :
                        undefined
                }
            </div>
        );
    }
}

function mapStateToProps(state, ownProps) {
    const residentData = (state.residentReducer && state.residentReducer.residentData) ? state.residentReducer.residentData : undefined;
    const residentSuccess = state.residentReducer;

    return {
        residentData: residentData,
        isResidentSuccess: residentSuccess
    };
}

export default connect(mapStateToProps, { getResidentsByCommunity, AddResident, PutUserByCommunity, UpdResident, DelResident, AddDetailsImage, BlockFamiliar, getALLResidentsByCommunityIDPagination, SyncResidentsByCommunity })(reduxForm({
    form: 'EditResidentForm',
    validate,
    enableReinitialize: true,
})(AddEditResident));